"use strict";

const vuestore = new Vuex.Store({
  modules: {
    base: vueBaseStore,
    cart: vuestoreCart,
    cabs: vuestoreCabs,
  },
});

var vueCartAppMessagesMixin = (function () {
  return {
    computed: {
      /*
      appCartGetSportswearBundlePrice() {
        switch (this.currentShop) {
          case 'CA':
            return 90;
          case 'AU':
            return 120;
          default:
            return 60;
        }
      },
      appCartBundleEligibleProducts() {
        if (!(typeof window.AppUserAgentDetected !== 'undefined' && window.AppUserAgentDetected)) {
          return [];
        }
        return this.standartProducts.filter(item => item.product_data.tags.includes('app_deal_030325_bundles'));
      },
      appCartSportswearBundleItems() {
        const bundleProducts = this.appCartBundleEligibleProducts;
        if (!bundleProducts.length) return { leggings: 0, bras: 0, tops: 0 };
        return {
          leggings: bundleProducts.filter(item => item.product_data.tags.includes('leggings')).reduce((sum, item) => sum + item.quantity, 0),
          bras: bundleProducts.filter(item => item.product_data.tags.includes('bras')).reduce((sum, item) => sum + item.quantity, 0),
          tops: bundleProducts.filter(item => item.product_data.tags.includes('tops')).reduce((sum, item) => sum + item.quantity, 0)
        };
      },
      appCartSportswearBundlesMissingItems() {
        if (!this.appCartBundleEligibleProducts.length) return [];
        const items = this.appCartSportswearBundleItems;
        const completeBundles = Math.min(items.leggings, items.bras, items.tops);
        const remaining = {
          leggings: items.leggings - completeBundles,
          bras: items.bras - completeBundles,
          tops: items.tops - completeBundles
        };
        const missing = [];
        if (Object.values(remaining).some(qty => qty > 0)) {
          if (remaining.leggings === 0) missing.push('leggings');
          if (remaining.bras === 0) missing.push('bras');
          if (remaining.tops === 0) missing.push('tops');
        }
        return missing;
      },
      appCartHasPartialSportswearBundle() {
        if (!(typeof window.AppUserAgentDetected !== 'undefined' && window.AppUserAgentDetected)) {
          return false;
        }
        if (!this.appCartBundleEligibleProducts.length) {
          return false;
        }
        const missingItems = this.appCartSportswearBundlesMissingItems;
        return missingItems.length > 0 && missingItems.length < 3;
      },
      */
    },
  };
})() || {};

var VueCart = Vue.extend({
  delimiters: vueDelimiters,
  props: ['settingSaleAjax', 'settingFashionpromo','settingFashionpromoValue', 'flatrateVariantids', 'flatrateProdids', 'flatratePrice', 'flatrateCompprice'],
  mixins: [vueCartAppMessagesMixin],
  data: function () {
    return {
      cartItems: [/* { product_data: {}, index: null }*/],
      loadcartItems: [],
      disableBtn: false,
      isBusy: false,
      cartType: null,
      giftscale: {
        settings: [],
        products: {},
      },
      cartData: {
        currencyCode: this.$store.getters['base/currencyCode'],
        priceSeparatorUs: this.$store.getters['base/priceSeparatorUs'],
        total_price: 0,
        original_total_price: 0,
        regularprice: 0,
        subtotal: 0,
        yousafe: 0,
        discount: "",
        discountLoading: false,
        removedDiscount: null,
        currentDiscount: null,
        discountData: null,
        discountValue: 0,
        discountPerc: 0,
        discountType: null,
        SuccessMessageCheck: false,
        SuccessMessage: null,
        dangerMessageCheck: false,
        dangerMessage: "",
        cartCount: 0,
        cartWeight: 0,
        cartShippingRate: 0,
        freeProductCount: 0,
        removedItem: [],
        removedItemId: null,
        removedItemTitle: null,
        removedItemSuccess: false,
        removedItemWishlistSuccess: false,
        removedItemQuantity: null,
        removedItemPrice: null,

        cartWishlistIds: [],
        cartWishlist: {},
        discount_applications: [],
        cartRewards: {gold:{},regular:{}},
        cartRewardsSelected: {
          gold:{selected: null,
            items: [],
            radioIndex: null,
            prevItem: null,
            disableReward: false,
            forceRemove: false,},
          regular:{selected: null,
            items: [],
            radioIndex: null,
            prevItem: null,
            disableReward: false,
            forceRemove: false,}
        },
      },
      cartError: null,
      adCookie: false,
      weekendDelay: false,
      offerShop: false,
      noteTracking: null,
      shippingFlatrate: {
        currentVersion: false,
        version: [
          {
            prodId: parseInt(this.flatrateProdids.split('|')[0]),
            variantId: parseInt(this.flatrateVariantids.split('|')[0]),
            price: parseInt(this.flatratePrice.split('|')[0]),
            compprice: parseInt(this.flatrateCompprice.split('|')[0])
          },
          {
            prodId: parseInt(this.flatrateProdids.split('|')[1]),
            variantId: parseInt(this.flatrateVariantids.split('|')[1]),
            price: parseInt(this.flatratePrice.split('|')[1]),
            compprice: parseInt(this.flatrateCompprice.split('|')[1])
          },
          {
            prodId: parseInt(this.flatrateProdids.split('|')[2]),
            variantId: parseInt(this.flatrateVariantids.split('|')[2]),
            price: parseInt(this.flatratePrice.split('|')[2]),
            compprice: parseInt(this.flatrateCompprice.split('|')[2])
          }
        ]
      },

      maxCartItemQuantity: 50,

      productVarId: "",
      fashionPromo: {
        promoProducts: {
          leggings: [],
          tops: []
        },
        leggingSelected: {
          selected: -1,
          selectedSize: -1
        },
        topSelected: {
          selected: -1,
          selectedSize: -1
        }
      },
      tracking: {
        changedItem: []
      },
      upsellPromo: {
        handle: null,
        product: null,
        selectedVariantId: null,
        selectedVariant: null,
        variantFilter: null,
        isInCart: false,
        adding: false,
        timerActive: false
      }
    };
  },

  mounted: function mounted() {
    this.cartItems = [];
    this.loadCart().finally(function () {
      setTimeout(function () {
        $('.se-pre-con').fadeOut(225);
      }, 200);
    });

    this.setupFreeGifts();

    this.cartChangedSelect();
    //this.subtotalCal();
    //this.checkDiscountFromCart();
    this.setUpDragSlide();
    // this.$store.dispatch('cabs/fetchCartCabs').then(function () {
    //   Vue.nextTick(function () {
    //     if (typeof window.equalHeightInstance !== 'undefined') {
    //       window.equalHeightInstance.update({ ignoreShopGrid: true, cache: true });
    //     }
    //     setTimeout(function(){
    //       $('.wb-cart-cab-item .selectpicker').selectpicker('refresh');
    //     },500);
    //   });
    // });
    this.rewardproducts();

    this.initUpsellPromo();

    this.checkOfferShop();


    if (this.$store.state.base.hasCustomer) {
      //self.wishlistProducts();
      //“Fixed it quickly; it should be properly fixed later.
      try {
        window.initProductSlider('#wishlist_slider');
      }catch(e){
        
      }
      

      Vue.nextTick(function () {
        if (typeof window.equalHeightInstance !== 'undefined') {
          window.equalHeightInstance.update({ ignoreShopGrid: true, cache: true });
        }
      });
    }

    // this.removeFreeProducts();

    this.weekendDelayCalc();

    //this.setupFlatrateShipping();


    //this.validateNoteTracking();
    window.addEventListener('scroll', throttle(150, this.showHideFixedCheckout), { passive: true });
    var sideCart = document.querySelector('.sidebar--cart');
    if(sideCart != undefined){
      sideCart.addEventListener('scroll', throttle(150, this.showHideFixedCheckout), { passive: true });
    }
    this.$nextTick(function () {
      // Check if cart is in dom/is rendered. If it there we can hide the checkout fallback button.
      var vueAppEl = document.getElementById('vue-app');
      if (vueAppEl) {
        var fallbackButton = document.getElementById('cart-checkout-fallback-btn');
        if (fallbackButton) {
          fallbackButton.style.display = 'none';
        }
      }
    });
  },

  methods: {

    ASFreeGift: function ASFreeGift(threshold, variant, product, message) {
      return { over: threshold, variant_id: variant, product_id: product, category: null, message: message }
    },
    ASFreeNutritionGift: function ASFreeNutritionGift(threshold, variant, product, message) {
      var gift = this.ASFreeGift(threshold, variant, product, message)
      gift.category = 'nutrition'
      return gift;
    },
    ASFreeSportswearGift: function ASFreeSportswearGift(threshold, variant, product, message) {
      var gift = this.ASFreeGift(threshold, variant, product, message)
      gift.category = 'sportswear'
      return gift;
    },
    getGiftInfo: function getGiftInfo() {
      var giftHandles = ['creatine-powder'];
      var productInfo = []
      giftHandles.forEach(function(handle,index){
        axios({
          url: "/products/" + handle + ".json",
          method: "get"
        })
          .then(function(response) {
            //console.log(response.data.product)
            productInfo.push(response.data.product);
            //console.log(index,giftHandles.length)
          })
          .catch(function(error) {
            console.log(error);
          });
      });
      vueapp.giftscale.products = productInfo;

    },
    setupFreeGifts: function setupFreeGifts(){
      var currentShop = this.$store.state.base.currentShop;

     

      // threshold1, variantid, productid, name      
    
      // let threshold1 = 20000,
      //   threshold2 = 20002,
      //   threshold3 = 20001;
      // if (currentShop === 'com') {
      //   threshold1 = 5000;
      //   threshold2 = 17000;
      //   threshold3 = 25000;
      //   this.giftscale.settings.push(
      //     this.ASFreeNutritionGift(threshold1, 56181336506743, 15242301309303, 'Vegan Daily Essentials Capsules'),
      //     /* this.ASFreeSportswearGift(threshold1, 39707627094105, 6977399488601, 'Crew Socks White'),
      //      this.ASFreeSportswearGift(threshold2, 49055407571279, 9339624554831, 'Large Sweat Towel'),
      //        this.ASFreeNutritionGift(threshold1, 48412683960655, 8488085913935, 'Shaker'),
      //        this.ASFreeNutritionGift(threshold2, 49209782960463, 9397608317263, 'Large Sweat Towel'),
      //        this.ASFreeNutritionGift(threshold3, 46598668157263, 8488085061967, 'Apple Cider Vinegar Gummies'),
      //        this.ASFreeSportswearGift(threshold1, 39707626963033, 6977399390297, 'Crew Socks Black'),
      //        this.ASFreeSportswearGift(threshold2, 54804198523255, 14871470309751, 'All Day Waffle Knit Beanie'),
      //        this.ASFreeSportswearGift(threshold3, 55109591957879, 14953592455543, 'Eco Squeeze Bottle'),*/
      //   );
      // } else if (currentShop === 'us') {
      //   threshold1 = 6500;
      //   threshold2 = 17000;
      //   threshold3 = 16000;
      //   this.giftscale.settings.push(
      //     this.ASFreeNutritionGift(threshold1, 51740159902043, 10206703386971, 'Vegan Daily Essentials Capsules'),
      //     /*this.ASFreeSportswearGift(threshold1, 39711247335489, 6733160972353, 'Crew Socks White'),
      //     this.ASFreeSportswearGift(threshold2, 48430740111707, 9250116534619, 'Large Sweat Towel'),
      //       this.ASFreeNutritionGift(threshold1, 47773647536475, 8408843354459, 'Shaker'),
      //       this.ASFreeNutritionGift(threshold2, 48579009184091, 9302590652763, 'Large Sweat Towel'),
      //       this.ASFreeNutritionGift(threshold3, 46711695737179, 8408841093467, 'Apple Cider Vinegar Gummies'),
      //       this.ASFreeSportswearGift(threshold1, 39711247204417, 6733160939585, 'Crew Socks Black'),
      //       this.ASFreeSportswearGift(threshold2, 49636609786203, 9622010134875, 'All Day Waffle Knit Beanie'),
      //       this.ASFreeSportswearGift(threshold3, 50387562692955, 9837633372507, 'Eco Squeeze Bottle'),*/
      //   );
      // } else if (currentShop === 'eu') {
      //   threshold1 = 5000;
      //   threshold2 = 13500;
      //   threshold3 = 16000;
      //   this.giftscale.settings.push(
      //     this.ASFreeNutritionGift(threshold1, 53910073246019, 15191071818051, 'Vegan Daily Essentials Capsules'),
      //     /*this.ASFreeSportswearGift(threshold1, 39577396609095, 6622821285959, 'Crew Socks White'),
      //     this.ASFreeSportswearGift(threshold2, 48530568872259, 9242653655363, 'Large Sweat Towel'),
      //      this.ASFreeNutritionGift(threshold1, 47985400086851, 8590005862723, 'Shaker'),
      //      this.ASFreeNutritionGift(threshold2, 48838931284291, 9408898728259, 'Large Sweat Towel'),
      //      this.ASFreeNutritionGift(threshold3, 46702472921411, 8590005043523, 'Apple Cider Vinegar Gummies'),
      //      this.ASFreeSportswearGift(threshold1, 39577396478023, 6622821220423, 'Crew Socks Black'),
      //      this.ASFreeSportswearGift(threshold2, 51778584805699, 14651139129667, 'All Day Waffle Knit Beanie'),
      //      this.ASFreeSportswearGift(threshold3, 52963470246211, 14899023184195, 'Eco Squeeze Bottle'),*/
      //   );
      // } else if (currentShop === 'ie') {
      //   threshold1 = 4000;
      //   threshold2 = 10000;
      //   threshold3 = 15000;
      //   this.giftscale.settings.push(
      //     this.ASFreeNutritionGift(threshold1, 54999583916417, 15241036038529, 'Vegan Daily Essentials Capsules'),
      //     /*this.ASFreeSportswearGift(threshold1, 41534526587052, 7267864215724, 'Crew Socks White'),
      //     this.ASFreeSportswearGift(threshold2, 49809836114251, 10007357456715, 'Large Sweat Towel'),
      //     this.ASFreeNutritionGift(threshold1, 47474231607627, 8485916803403, 'Shaker'),
      //     this.ASFreeNutritionGift(threshold2, 49952751583563, 10061619003723, 'Large Sweat Towel'),
      //     this.ASFreeNutritionGift(threshold3, 46538288595275, 8485914771787, 'Apple Cider Vinegar Gummies'),
      //     this.ASFreeSportswearGift(threshold1, 41534527242412, 7267864477868, 'Crew Socks Black'),
      //     this.ASFreeSportswearGift(threshold2, 50940403417419, 10356059963723, 'All Day Waffle Knit Beanie'),
      //     this.ASFreeSportswearGift(threshold3, 54212448846209, 15042040627585, 'Eco Squeeze Bottle'),*/
      //   );
      // } else if (currentShop === 'uk') {
      //   threshold1 = 4500;
      //   threshold2 = 10500;
      //   threshold3 = 12000;
      //   this.giftscale.settings.push(
      //     this.ASFreeNutritionGift(threshold1, 53360863084873, 9933010927945, 'Vegan Daily Essentials Capsules'),
      //     /*this.ASFreeSportswearGift(threshold1, 39834765099113, 6790883082345, 'Crew Socks White'),
      //     this.ASFreeSportswearGift(threshold2, 50159902327113, 9105614504265, 'Large Sweat Towel'),
      //     this.ASFreeNutritionGift(threshold1, 49605588549961, 8396029591881, 'Shaker'),
      //     this.ASFreeNutritionGift(threshold2, 50297607323977, 9152607420745, 'Large Sweat Towel'),
      //     this.ASFreeNutritionGift(threshold3, 46697837560137, 8396027855177, 'Apple Cider Vinegar Gummies'),
      //     this.ASFreeSportswearGift(threshold1, 39834764935273, 6790883016809, 'Crew Socks Black'),
      //     this.ASFreeSportswearGift(threshold2, 32748309020777, 4778909106281, 'Short Resistance Band'),
      //     this.ASFreeSportswearGift(threshold3, 52040057880905, 9612094112073, 'Hot/Cold Bottle'),*/
      //   );
      // } else if (currentShop === 'au') {
      //   threshold1 = 6500;
      //   threshold2 = 16000;
      //   threshold3 = 25000;
      //   this.giftscale.settings.push(
      //     this.ASFreeNutritionGift(threshold1, 51911637500245, 10268060385621, 'Vegan Daily Essentials Capsules'),
      //     /* this.ASFreeSportswearGift(threshold1, 39433874571360, 6592955088992, 'Crew Socks White'),
      //      this.ASFreeSportswearGift(threshold2, 48497068835157, 9172811284821, 'Large Sweat Towel'),
      //      this.ASFreeNutritionGift(threshold1, 46724465394005, 8592558391637, 'Shaker'),
      //      this.ASFreeNutritionGift(threshold2, 49086290067797, 9421754859861, 'Large Sweat Towel'),
      //      this.ASFreeNutritionGift(threshold3, 46724457169237, 8592555180373, 'Apple Cider Vinegar Gummies'),
      //      this.ASFreeSportswearGift(threshold1, 39433874473056, 6592955056224, 'Crew Socks Black'),
      //      this.ASFreeSportswearGift(threshold2, 49983509496149, 9707480449365, 'All Day Waffle Knit Beanie'),
      //      this.ASFreeSportswearGift(threshold3, 50588263186773, 9879989256533, 'Eco Squeeze Bottle'),*/
      //   );
      // } else if (currentShop === 'ca') {
      //   threshold1 = 6500;
      //   threshold2 = 15500;
      //   threshold3 = 25000;
      //   this.giftscale.settings.push(
      //     this.ASFreeNutritionGift(threshold1, 55935533777220, 15366725009732, 'Vegan Daily Essentials Capsules'),
      //     /*this.ASFreeSportswearGift(threshold1, 39526167019578, 6727624753210, 'Crew Socks White'),
      //     this.ASFreeSportswearGift(threshold2, 48641385759044, 9119951749444, 'Large Sweat Towel'),
      //     this.ASFreeNutritionGift(threshold1, 48051359580484, 8498214994244, 'Shaker'),
      //     this.ASFreeNutritionGift(threshold2, 48800161268036, 9402098385220, 'Large Sweat Towel'),
      //     this.ASFreeNutritionGift(threshold3, 46581086650692, 8498214437188, 'Apple Cider Vinegar Gummies'),
      //     this.ASFreeSportswearGift(threshold1, 39526166855738, 6727624654906, 'Crew Socks Black'),
      //     this.ASFreeSportswearGift(threshold2, 53835654824260, 14851694428484, 'All Day Waffle Knit Beanie'),
      //     this.ASFreeSportswearGift(threshold3, 54617466241348, 15054718599492, 'Eco Squeeze Bottle'),*/
      //   );
      // } else if (currentShop === 'de') {
      //   threshold1 = 4500;
      //   threshold2 = 9000;
      //   threshold3 = 16000;
      //   this.giftscale.settings.push(
      //     this.ASFreeNutritionGift(threshold1, 51951160688981, 10278450266453, 'Vegan Daily Essentials Capsules'),
      //     /*this.ASFreeSportswearGift(threshold1, 39577397002311, 6622821384263, 'Crew Socks White'),
      //     this.ASFreeSportswearGift(threshold2, 48497070178645, 9172811678037, 'Large Sweat Towel'),
      //     this.ASFreeNutritionGift(threshold1, 47978332389717, 8592562192725, 'Shaker'),
      //     this.ASFreeNutritionGift(threshold2, 49086290133333, 9421754925397, 'Large Sweat Towel'),
      //     this.ASFreeNutritionGift(threshold3, 46724467982677, 8592558850389, 'Apple Cider Vinegar Gummies'),
      //     this.ASFreeSportswearGift(threshold1, 39577396904007, 6622821351495, 'Crew Socks Black'),
      //     this.ASFreeSportswearGift(threshold2, 49983509463381, 9707480416597, 'All Day Waffle Knit Beanie'),
      //     this.ASFreeSportswearGift(threshold3, 50588263448917, 9879989354837, 'Eco Squeeze Bottle'),*/
      //   );
      // } else if (currentShop === 'fr') {
      //   threshold1 = 4500;
      //   threshold2 = 12000;
      //   threshold3 = 15000;
      //   this.giftscale.settings.push(
      //     this.ASFreeNutritionGift(threshold1, 54999584014721, 15241036169601, 'Vegan Daily Essentials Capsules'),
      //     /* this.ASFreeSportswearGift(threshold1, 41421182304451, 7123680035011, 'Crew Socks White'),
      //      this.ASFreeSportswearGift(threshold2, 48759393681745, 9211825160529, 'Large Sweat Towel'),
      //       this.ASFreeNutritionGift(threshold1, 48162962276689, 8602223083857, 'Shaker'),
      //       this.ASFreeNutritionGift(threshold2, 48910202044753, 9271320346961, 'Large Sweat Towel'),
      //       this.ASFreeNutritionGift(threshold3, 46614581444945, 8602220495185, 'Apple Cider Vinegar Gummies'),
      //       this.ASFreeSportswearGift(threshold1, 41421182107843, 7123679903939, 'Crew Socks Black'),
      //       this.ASFreeSportswearGift(threshold2, 53799459062145, 14877295083905, 'All Day Waffle Knit Beanie'),
      //       this.ASFreeSportswearGift(threshold3, 54212448780673, 15042040562049, 'Eco Squeeze Bottle'),*/
      //   );
      // } else if (currentShop === 'at') {
      //   threshold1 = 4500;
      //   threshold2 = 9000;
      //   threshold3 = 17000;
      //   this.giftscale.settings.push(
      //     this.ASFreeNutritionGift(threshold1, 57429587296637, 15682270855549, 'Vegan Daily Essentials Capsules'),
      //     /*this.ASFreeSportswearGift(threshold1, 41686378872983, 7408552149143, 'Crew Socks White'),
      //    this.ASFreeSportswearGift(threshold2, 48497070506325, 9172811710805, 'Large Sweat Towel'),
      //   this.ASFreeNutritionGift(threshold1, 47978329768277, 8592562422101, 'Shaker'),
      //    this.ASFreeNutritionGift(threshold2, 49086290035029, 9421754827093, 'Large Sweat Towel'),
      //    this.ASFreeNutritionGift(threshold3, 46724468113749, 8592558915925, 'Apple Cider Vinegar Gummies'),
      //    this.ASFreeSportswearGift(threshold1, 41686378774679, 7408552116375, 'Crew Socks Black'),
      //    this.ASFreeSportswearGift(threshold2, 54948250354045, 14883410346365, 'All Day Waffle Knit Beanie'),
      //    this.ASFreeSportswearGift(threshold3, 55730053808509, 15140901749117, 'Eco Squeeze Bottle'),*/
      //   );
      // }
    },
     checkCartType: function checkCartType(init){
      var items = Array.from(this.cartItems).reverse();
       items.forEach(function (item) {
         if ((item.properties != null && ((item.properties._reward != undefined || item.properties._regular_reward != undefined || item.properties.reward != undefined))) || (item.properties != null && (item.properties._giftpromo != undefined || item.properties.giftpromo != undefined))) {
           return;
         }

         if (!true) { //first product nutrition o sportswear
           if (vueapp.cartType == null || init) {
             if (item.product_type.indexOf('Sportswear') !== -1) {
               vueapp.cartType = "sportswear";
               init = false;
               //console.log('vue cart type ',vueapp.cartType);
               return false;
             } else {
               vueapp.cartType = "nutrition";
               init = false;
               //console.log('vue cart type ',vueapp.cartType);
               return false;
             }
           }
         } else { // at least one product with nutrition o sportswear
           if (vueapp.nutritionProducts.length > 0) {
             vueapp.cartType = "nutrition";
             return false;
           } else {
             vueapp.cartType = "sportswear";
             return false;
           }
         }
      });
    },
    // compare price formatter
    compareformat: function (value, index, qty) {
      return this.moneyformat(value.replace('.', '') * qty);
    },
    // compare price formatter for free section
    compareformatfree: function (value, index, qty) {
      var comparePrice = ((value / 100) * qty)
        .toFixed(2)
        .toString()
        .replace(".", ",");

      return this.$store.getters['base/currencySymbol'] + " " + comparePrice;
    },
    // price formatter for Tracking
    moneyformatTracking: function (value) {
      return (value / 100).toFixed(2).toString();
    },

    validateRewardProduct: function validateRewardProduct(item) {
      if(item.properties != null && ((item.properties._regular_reward && item.properties._regular_reward === true) || (item.properties._reward && item.properties._reward === true) || (item.properties.reward && item.properties.reward === true))){
        var rewardItem = item;
        var rewardIndex = 0;
        if(this.cartData?.cartRewards?.gold.length && (item.properties._reward && item.properties._reward === true)){
         // console.log('this.cartData.regular',this.cartData.cartRewards.regular)
          this.cartData.cartRewards.gold.forEach(function(item,index){
            if(rewardItem.product_id == item.id){
              rewardIndex = index;

            }
          });

          if(this.cartData.cartRewardsSelected.gold.forceRemove !== true){
            if(this.cartData.cartRewardsSelected.gold.radioIndex == null){
              this.cartData.cartRewardsSelected.gold.radioIndex = rewardIndex;

              this.cartData.cartRewardsSelected.gold.prevItem = rewardItem.id;
              //console.log(rewardItem.variant_options[0], rewardItem.id);
            }
          }

        }
        if(this.cartData.cartRewards.regular.length && (item.properties._regular_reward && item.properties._regular_reward === true)){
          this.cartData.cartRewards.regular.forEach(function(item,index){
            if(rewardItem.product_id == item.id){
              rewardIndex = index;

            }
          });

          if(this.cartData.cartRewardsSelected.regular.forceRemove !== true){
            if(this.cartData.cartRewardsSelected.regular.radioIndex == null){
              this.cartData.cartRewardsSelected.regular.radioIndex = rewardIndex;

              this.cartData.cartRewardsSelected.regular.prevItem = rewardItem.id;
              //console.log(rewardItem.variant_options[0], rewardItem.id);
            }
          }

        }
        return true;
      }else{
        return false;
      }
    },

    setupFlatrateShipping: function setupFlatrateShipping() {

      function getRandomInt(max) {
        return Math.floor(Math.random() * max);
      }

      if(Number.isInteger(this.shippingFlatrate.version[0].variantId)) {

        if(Cookies.get('flatrateversion') != undefined){
          this.shippingFlatrate.currentVersion = Cookies.get('flatrateversion');
        }else {
          var newCurrentVersion = getRandomInt(3);
          Cookies.set('flatrateversion', newCurrentVersion, {expires: 7, path: '/', domain: '.womensbest.com'});
          this.shippingFlatrate.currentVersion = newCurrentVersion;
          window.wbTracking('flatrateoffer', { flatrateVersion: this.shippingFlatrate.currentVersion});
        }
      }


    },

    flatrateClick: function flatrateClick() {

      $('.cart_shipping-flatline-content-intro').toggleClass('open');
      $('.cart_shipping-flatline-content-info').slideToggle(200, function () {

      });
    },
    weekendDelayCalc: function weekendDelayCalc() {

      var d = new Date(),
        localTime = d.getTime(),
        localOffset = d.getTimezoneOffset() * 60000,
        utc = localTime + localOffset,
        utcDate = new Date(utc);

      //console.log(utcDate.getHours())


      if(utcDate.getDay() == 6 || utcDate.getDay() == 0 || (utcDate.getDay() == 5 && utcDate.getHours() > 15)){
        this.weekendDelay = true;
      }

      //this.weekendDelay = true;
    },
    meCartSubmit: function meCartSubmit(e) {
      e.preventDefault();
      window.location.pathname = '/en/checkout';
    },
    fashionSetImgAdjustment: function(){
      this.cartItems.forEach(function (item, index){
        if(item.product_type !== "Sportswear/Set/"){return;}
        if(item.properties == undefined || item.properties.bundleproducts == undefined ){return;}
        var propertieIndex = 0;
        if(item.properties.bundleproducts[Object.keys(item.properties.bundleproducts)[propertieIndex]].indexOf('Socks') != -1){propertieIndex=1;}

        var propertieItem = item.properties.bundleproducts[Object.keys(item.properties.bundleproducts)[propertieIndex]];
        var color = propertieItem.split(',')[0].split('|')[1].replaceAll(' ','');
        var image = item.product_data.images.filter(function(img){return img.src.indexOf(color) !== -1});
        if(image[0] != undefined){
          item.image = image[0].src;
        }
      })
    },
    bundleValidation: function bundleValidation(){
      this.bundleProducts.forEach(function (item, index) {
        var itemPropLength = Object.keys(JSON.parse(JSON.stringify(item.properties.bundleproducts))).length;
        var itemHandle = item.handle.replace('-offer','');

        var validValues = {
          "bundleProducts":[
            {"bundle":"amino-energy-by-vicky-justiz-xl-shaker", "size":"2"},{"bundle":"bcaa-amino-by-krissy-cela-xl-shaker", "size":"2"},{"bundle":"bcaa-amino-by-tammy-hembrow-xl-shaker", "size":"2"},{"bundle":"bcaa-amino-by-vicky-justiz-xl-shaker", "size":"2"},{"bundle":"fit-pro-whey-protein-by-krissy-cela-xl-shaker", "size":"2"},{"bundle":"fit-pro-whey-protein-by-tammy-hembrow-xl-shaker", "size":"2"},{"bundle":"fit-pro-whey-protein-by-vicky-justiz-xl-shaker", "size":"2"},{"bundle":"health-bundle", "size":"4"},{"bundle":"krissys-all-in-one-bundle", "size":"5"},{"bundle":"krissys-fit-bundle", "size":"4"},{"bundle":"krissys-vegan-bundle", "size":"4"},{"bundle":"krissys-workout-bundle", "size":"3"},{"bundle":"muscle-bundle", "size":"5"},{"bundle":"muscle-bundle-pro", "size":"5"},{"bundle":"pre-workout-booster-by-krissy-cela-xl-shaker", "size":"2"},{"bundle":"shape-body-shake", "size":"2"},{"bundle":"shape-body-shake-burner-shaker", "size":"3"},{"bundle":"shape-bundle", "size":"3"},{"bundle":"shape-bundle-pro", "size":"4"},{"bundle":"tammys-all-in-one-bundle", "size":"5"},{"bundle":"tammys-fit-bundle", "size":"3"},{"bundle":"tammys-vegan-bundle", "size":"3"},{"bundle":"true-beauty-by-tammy-hembrow-xl-shaker", "size":"2"},{"bundle":"vegan-protein", "size":"2"},{"bundle":"vegan-protein-by-krissy-cela-xl-shaker", "size":"2"},{"bundle":"vegan-protein-by-tammy-hembrow-xl-shaker", "size":"2"},{"bundle":"vickys-all-in-one-bundle", "size":"4"},{"bundle":"vickys-fit-bundle", "size":"3"},{"bundle":"vickys-workout-bundle", "size":"3"},{"bundle":"weight-gain-bundle", "size":"4"},{"bundle":"weight-loss-bundle", "size":"4"},{"bundle":"weight-loss-bundle-pro", "size":"5"},{"bundle":"workout-bundle", "size":"3"}]
        }
        var doubleProducts = ['beauty-bundle-pro','muscle-bundle-pro','weight-gain-bundle','weight-loss-bundle-pro','slim-body-shake-duo-pack','fit-whey-duo-pack-1000','pre-workout-booster-duo-pack','bcaa-amino-duo-pack','amino-energy-duo-pack','vegan-protein-duo-pack','weight-loss-bundle-pro-750','fit-whey-duo-pack-500','muscle-bundle-500'];
        validValues.bundleProducts.forEach(function(item){
          var validationSize = item.size;

          if(doubleProducts.indexOf(itemHandle)!=-1){
            validationSize = parseInt(validationSize) + 1;
          }

          if(item.bundle == itemHandle && validationSize != itemPropLength){
            document.dispatchEvent(new CustomEvent('wb:checkffraud'));
          }
        });

        //console.log('bundle length ',itemHandle,itemPropLength);

      });
    },
    setUpDragSlide: function setUpDragSlide() {
      let mouseDown = false;
      let startX, scrollLeft;
      const sliders = document.querySelectorAll('.wb-cart--scrollbar');

      if(sliders.length == 0){
        return;
      }

      sliders.forEach(function(slider){
        if(slider.classList.contains('slide--applied')){return;}
        const startDragging = (e) => {
          mouseDown = true;
          startX = e.pageX - slider.offsetLeft;
          scrollLeft = slider.scrollLeft;
        }

        const stopDragging = (e) => {
          mouseDown = false;
        }

        const move = (e) => {
          e.preventDefault();
          if(!mouseDown) { return; }
          const x = e.pageX - slider.offsetLeft;
          const scroll = x - startX;
          slider.scrollLeft = scrollLeft - scroll;
        }
        slider.addEventListener('mousemove', move, false);
        slider.addEventListener('mousedown', startDragging, false);
        slider.addEventListener('mouseup', stopDragging, false);
        slider.addEventListener('mouseleave', stopDragging, false);
        slider.classList.add('slide--applied');

      });
    },
    checkOfferShop: function checkOfferShop(){
      if(window.Cookies.get('special-offer')!==undefined){
        this.offerShop = true;

      }
    },
    checkCookieForAd: function checkCookieForAd(){
      var adDiscountName = 'IDJW4Q';
      var cookiediscount = Cookies.get('ad-script', {domain: '.womensbest.com'});
      //console.log('cookie discount' , cookiediscount)
      if(cookiediscount == adDiscountName){
        this.adCookie = true;
        this.cartData.discount = adDiscountName;
      }
    },

    showHideFixedCheckout: function showHideFixedCheckout() {
      if (!this.$refs.priceListingTotal || !this.$refs.fixedPriceListingTotal || !this.$refs.checkoutFixed) {
        return;
      }
      return;
      var ot = (this.$refs.priceListingTotal.getBoundingClientRect().bottom || 0) + (window.scrollY || document.documentElement.scrollTop) - (document.documentElement.clientTop  || 0);
      var otF = (this.$refs.fixedPriceListingTotal.getBoundingClientRect().top || 0) + (window.scrollY || document.documentElement.scrollTop) - (document.documentElement.clientTop  || 0);
      var x = window.screen.height + window.scrollY;
      if (ot - x < 0) {
        this.$data.hasSeenPriceListingTotal = true;
      }
      if (this.$data.hasSeenPriceListingTotal !== true) {
        //return;
      }
      var hide = parseInt(otF) - parseInt(ot) > 0;
      if (document.getElementById('smile-ui-container') !== null) {
        var smileFContainer = document.getElementById('smile-ui-container').querySelector('.smile-launcher-frame-container');
        if(smileFContainer !== null){
          smileFContainer.style.marginBottom = hide ? 0 : this.$refs.checkoutFixed.offsetHeight + 'px';
        }
      }
      this.$refs.checkoutFixed.style.transform = hide ? '' : 'none';
      this.$refs.checkoutFixed.style.height = hide ? '' : 'auto';
    },

    //load cart information
    loadCart: function loadCart() {
      var self = this;
      this.isBusy = true;
      this.disableBtn = true;

      return Promise.all([
        this.$store.dispatch('cart/fetch'),

        axios({
          url: "/cart.json",
          method: "get",
          headers: { 'Cache-Control': 'no-cache, no-store', 'Pragma': 'no-cache', 'Expires': 0 }
        })
          .then(function(response) {
            self.cartData.total_price = response.data.total_price;
            self.cartData.original_total_price = response.data.original_total_price;
            self.cartData.discount_applications = response.data.cart_level_discount_applications || [];
            
            self.loadcartItems = response.data.items.map(function(item) {
              item.product_data = {};
              item.product_data_status = false;
              return item;
            });

            return Promise.all(self.loadcartItems.map(self.getProductDataByItem))
              .then(function (product_datas) {
                self.loadcartItems.forEach(function (item, index) {
                  if (product_datas[index]) {
                    item.product_data = product_datas[index];
                    item.product_data_status = true;
                  }
                });

                // Handle unpublished products
                self.loadcartItems = self.loadcartItems.filter(function (item) {
                  return item.product_data_status;
                });

                self.checkloadedcartItems();
                self.subtotalCal();

                if (self.loadcartItems.length < 1) {
                  self.cartData.cartCount = 0;
                  self.cartItems = self.loadcartItems;
                }
              });
          })
          .catch(function(error) {
            console.log(error);
            self.cartError = true;
            self.scrollToTop();
            throw error;
          })
      ]).catch(function(error) {
        console.log(error);
        self.cartError = true;
        self.scrollToTop();
        throw error;
      }).catch(function(error) {
        // Allow error to propagate to error tracking services
      });
    },

    scrollToTop: function scrollToTop() {
      window.scrollTo(0,0);
    },
    // change quantity of cartitem
    itemChange: function itemChange(item, index, value) {
      var self = this;
      var forceReduction = false;
      if(item.sku == "9010128000807" || item.sku == "9010128008162"){
        var saleItemQty = 0;
        self.cartItems.forEach(function(itemc, index) {
          if(itemc.sku == "9010128000807" || itemc.sku == "9010128008162"){
            saleItemQty = saleItemQty + itemc.quantity;
          }
        });
        if(saleItemQty % 2 === 0 ){
          if(value < 0){
            value = -2;
          }else if (value > 0){
            value = 2;
          }
        }else{}
        //console.log(value);
        if(item.quantity + value == 0){
          //console.log('remove item if not disabled');
          var forceReduction = true;
        }
      }

      if (self.disableBtn == true) {
        return;
      } else {
        if (item.quantity + value < 1 && forceReduction == false) {
          return;
        } else if (item.quantity + value > this.maxCartItemQuantity) {
          alert("not more than " + this.maxCartItemQuantity + " pieces");
          item.quantity = this.maxCartItemQuantity - 1;
        }
        var itemId = item.id;
        var itemQty = item.quantity + value;

        var quantity = this.cartItems[index].quantity + value;

        // BOGO product: +2 or -2 if total quantity is even, else just +1 or -1 to fix the quantity.
        //if (item.properties && item.properties.returnable === '0' && this.cartItems.filter(function(i) { return i.handle === item.handle; }).reduce(function (sum, i) { return sum + i.quantity; }, 0) % 2 === 0) {
        //  quantity = this.cartItems[index].quantity + (value * 2);
        //}

        axios({
          url: "/cart/change.json",
          method: "post",
          data: {
            quantity: quantity,
            line: index + 1
          }
        })
          .then(function(response) {
            document.dispatchEvent(new CustomEvent('wb:checkloadedcartItems'));
            self.loadCart();
            document.dispatchEvent(new CustomEvent('wb:changecarttracking', { detail: { sku: item.sku, qty: value } }));
            self.subtotalCal();
          })
          .catch(function(error) {
            self.cartError = error.response?.data?.errors ?? true;
            self.scrollToTop();
            console.log(error);
            return console.log(error);
          });
      }
    },
    // change cartData by jsonData
    changeCart: function changeCart(postData) {
      var self = this;
      axios({
        url: "/cart/change.json",
        method: "post",
        data: postData
      })
        .then(function(response) {
          self.loadCart();
          self.subtotalCal();
        })
        .catch(function(error) {
          return console.log(error);
        });
    },

    // remove item from cart
    removeItem: function removeItem(item, index, options = {}) {
      var self = this;
      axios({
        url: "/cart/change.json",
        method: "post",
        data: {
          quantity: 0,
          line: item.index + 1
        }
      })
        .then(function(response) {

          if(item.properties._giftpromo == undefined || item.properties.giftpromo == undefined){
            self.cartData.removedItem = item;
            self.cartData.removedItemQuantity = item.quantity;
            self.cartData.removedItemPrice = item.price;
            self.cartData.removedItemTitle = (item.title ?? '').replace(' | ', ' - ');
            if (options?.savedToWishlist === true) {
              self.cartData.removedItemWishlistSuccess = true;
            } else {
              self.cartData.removedItemSuccess = true;
            }
          }


          self.loadCart();
          self.subtotalCal();
          document.dispatchEvent(new CustomEvent('wb:checkloadedcartItems'));
          document.dispatchEvent(new CustomEvent('wb:removecarttracking', { detail: { sku: item.sku, qty: '-'+item.quantity } }));
        })
        .catch(function(error) {
          return console.log(error);
        });

      this.eeRemoveCart(item, index, "removeFromCart");
    },

    // add item after deleteing it from cart
    readdItem: function readdItem() {
      var self = this;
      var item = this.cartData.removedItem;

      axios({
        url: "/cart/add.json",
        method: "post",
        data: item
      }).then(function(response) {
        //console.log('itemreadded');
        self.cartData.removedItemSuccess = false;
        self.cartData.removedItemWishlistSuccess = false;
        self.loadCart();
        self.cartChangedSelect();
        self.genericEvent(
          "genericEvent",
          "Cart",
          "Undo",
          self.cartData.removedItemTitle
        );

        // GTM tracking
        if (typeof window.callGTMTracking === 'function') {
          window.callGTMTracking('CART-undo-remove');
        }
      });
    },

    //Subtotal & Cart Count Calculation
    subtotalCal: function subtotalCal() {
      var cartCount = 0;
      var sum = 0;
      var sumreg = 0;
      var totalWeight = 0;

      if (this.standartProducts.length > 0) {
        for (var i = 0; i < this.standartProducts.length; i++) {
          var lineWeight =
            this.standartProducts[i].grams * this.standartProducts[i].quantity;

          var variantIndex = this.standartProducts[i].product_data.variants.findIndex(itemvariant => itemvariant.sku == this.standartProducts[i].sku);
          var variant = variantIndex !== -1 ? this.standartProducts[i].product_data.variants[variantIndex] : null;

          if (variant && variant.compare_at_price > 1) {
            var price = this.standartProducts[i].line_price;
            var compareLineTotal =
              variant.compare_at_price *
              100 *
              this.standartProducts[i].quantity;
            sumreg += compareLineTotal;
            sum += price;
          } else {
            var price = this.standartProducts[i].line_price;
            sumreg += price;
            sum += price;
          }
          totalWeight += lineWeight;
          var price = this.standartProducts[i].line_price;
          if (price > 0 && this.standartProducts[i].handle != "routeins") {
            cartCount += this.standartProducts[i].quantity;
          }
        }
      }

      this.cartData.cartWeight = totalWeight;
      //this.cartData.total_price = this.cartData.subtotal + this.cartData.cartShippingRate;
      this.cartData.subtotal = sum;
      this.cartData.regularprice = sumreg;
      this.cartData.cartCount = cartCount;
      //vueappCount.cartCount = this.cartData.cartCount;
      window.wbHeader.loadCartCount();
      this.totalCal();
      this.youSafeCal();
      this.smileBPCalc();

      if (this.cartData.subtotal > parseInt(this.settingFashionpromoValue) || this.settingSaleAjax === 'true') {
        document.dispatchEvent(new CustomEvent('wb:checkloadedcartItems'));
      }
    },

    smileBPCalc: function smileBPCalc() {
      if (this.$refs.cartSummarySmilePPValue) {
        var bp_multi = this.$refs.cartSummarySmilePPValue.dataset.bp_multi;
        var totalBestpoints = null;
        this.cartItems.filter(function(item) {if(item.product_data.tags.indexOf('product_line_promotions') == -1){totalBestpoints = totalBestpoints + item.final_line_price}})
        this.$refs.cartSummarySmilePPValue.innerText = Math.round(totalBestpoints * bp_multi / 100);
      }
    },

    //Cart total calculation
    totalCal: function totalCal() {
      var self = this;
      //shipping Total Cal
      if(this.adCookie == true){
        var cartTotal = 0;
        setTimeout(function(){
          //console.log('carttotal adjusted');
          $('[data-ad-price]').each(function(){ cartTotal += parseInt($(this).attr('data-ad-price'))})
          self.cartData.total_price = cartTotal
          // console.log('carttotal adjusted');
        },500);
      }else{

        if (this.cartData.cartWeight > 1500) {
          this.cartData.cartShippingRate = 0;
        } else {
          this.cartData.cartShippingRate = 0;
        }

        if (this.cartData.cartShippingRate > 0) {
          if (
            this.cartData.cartShippingRate > 0 &&
            this.cartData.discountPerc > 0
          ) {
            //console.log('test3');
            this.cartData.total_price =
              this.cartData.subtotal +
              this.cartData.cartShippingRate -
              Math.floor(
                this.cartData.subtotal * (this.cartData.discountPerc / 100)
              );
          } else if (
            this.cartData.cartShippingRate > 0 &&
            this.cartData.discountPerc == 0
          ) {
            this.cartData.total_price =
              this.cartData.subtotal + this.cartData.cartShippingRate;
            //console.log('test2');
          } else {
            this.cartData.total_price = this.cartData.subtotal;
            //console.log('test1');
          }
        } else {
          if (this.cartData.discountPerc > 0) {
            //console.log('test3');
            this.cartData.total_price =
              this.cartData.subtotal -
              Math.floor(
                this.cartData.subtotal * (this.cartData.discountPerc / 100)
              );
          } else {
            this.cartData.total_price = this.cartData.subtotal;
            //console.log('test1');
          }
        }

      }
    },

    //you safe cal
    youSafeCal: function youSafeCal() {
      var savings = this.cartData.regularprice - this.cartData.subtotal;
      this.cartData.yousafe = savings;
    },

    // request and save productdata for cartItem
    getProductDataByItem: function getProductDataByItem(item) {
      // recharge product exception
      if(item.properties != null && item.properties.shipping_interval_frequency != undefined){
        var preProductHandle = item.url.match(/([^\/\?]*)(\?.*)?$/)[1].split('-');
        preProductHandle.pop();
        var productHandle = preProductHandle.join('-');
      }else{
        var productHandle = item.url.match(/([^\/\?]*)(\?.*)?$/)[1];
      }
      return axios({
        url: "/products/" + productHandle + ".json",
        method: "get"
      })
        .then(function(response) {
          return response.data.product
        })
        .catch(function(error) {
          console.log(error);
          //window.location.href='/checkout';
          return Promise.resolve();
        });
    },

    // if all productdata of loadcartItems are loaded > set cartItems to loadcartItems
    // (no flicker on screens while cart and products are updated in background
    // with 'loadcartItems' and 'cartItems' are untouched)
    checkloadedcartItems: function checkloadedcartItems() {

      if (
        this.loadcartItems.filter(function(item) {
          return !item.product_data_status;
        }).length === 0
      ) {
        this.cartItems = this.loadcartItems;
        for (var i = 0; i < this.cartItems.length; i++) {
          this.cartItems[i].index = i;
        }

        this.isBusy = false;
        this.disableBtn = false;
        this.cartChangedSelect();

        this.fashionpromoproducts();


        this.checkCartType(true);
        this.bundleValidation();
        this.fashionSetImgAdjustment();
        //this.checkFreeGiftsFraud();
        //console.log('check loaded')

      }


    },
    // change cartitem variant
    // seems not to be possible, so clearing cart and rebuilt cart by 'buildCartByItems'
    changeVariant: function changeVariant(item) {
      this.onChangeTracking(item);
      var self = this;
      this.isBusy = true;
      this.buildcartItems = this.cartItems.filter(function(item) {
        return true;
      });
      axios({
        url: "/cart/clear.json",
        method: "post"
      })
        .then(function(response) {
          self.buildCartByItems();
        })
        .catch(function(error) {
          return console.log(error);
        });
    },

    // rebuild new cart by current cartitems arry
    buildCartByItems: function buildCartByItems() {
      if (this.buildcartItems.length > 0) {
        var item = this.buildcartItems.pop();

        var index = item.index;
        var discountPrice = item.discounted_price;
        var postData = [];

        if (discountPrice < 1) {
          var postData = {
            quantity: item.quantity,
            id: item.variant_id,
            properties: { alreadydiscounted: true }
          };
        } else {
          var postData = {
            quantity: item.quantity,
            id: item.variant_id
          };
        }

        var properties = item.properties;

        if (properties) {
          var postData = {
            quantity: item.quantity,
            id: item.variant_id,
            properties: properties
          };
        }

        var self = this;

        axios({
          url: "/cart/add.json",
          method: "post",
          data: postData
        })
          .then(function(response) {
            self.buildCartByItems();

            // GTM tracking
           // window.callGTMTracking('cart-engraving');
          })
          .catch(function(error) {
            return console.log(error);
          });
      } else {
        this.loadCart();
      }
    },

    // simple add product ( mainly for adding free products )
    addProduct: function addProduct(variantid, productid) {
      var self = this;

      if (typeof window.callGTMTracking === 'function') {
        window.callGTMTracking('CART-add-product');
      }
      axios
        .post("/cart/update.json", "updates[" + variantid + "]=1")
        .then(function(response) {
          self.buildCartByItems();
          //console.log("item added");
        })
        .catch(function(error) {
          return console.log(error);
        });
    },
    addProductClick: function addProductClick(variantid, productid) {
      var self = this;

      if (typeof window.callGTMTracking === 'function') {
        window.callGTMTracking('CART-add-product');
      }
      axios
        .post("/cart/add.js", {
          quantity: 1,
          id: variantid
        })
        .then(function(response) {
          self.loadCart();
          //console.log("item added");
          document.dispatchEvent(new CustomEvent('wb:checkloadedcartItems'));
          document.dispatchEvent(new CustomEvent('wb:addtocarttracking', { detail: { sku: response.data.sku, qty: '1', title: response.data.title, prodID: response.data.product_id, variantID: response.data.variant_id } }));
        })
        .catch(function(error) {
          return console.log(error);
        });
    },
    // simple delete product ( mainly for deleting free products )
    deleteProduct: function deleteProduct(variantid, productid) {
      var itemInCart;
      this.cartItems.filter(function(item) {
        if (item.product_id == productid) {
          itemInCart = true;
        } else {
          console.log("item is not in cart");
        }
      });

      if (itemInCart == true) {
        var self = this;

        axios
          .post("/cart/update.json", "updates[" + variantid + "]=0")
          .then(function(response) {
            self.buildCartByItems();
            console.log("item deleted");
          })
          .catch(function(error) {
            return console.log(error);
          });
      } else {
        this.loadCart();
      }
    },

    // refresh bootstrap-select selectpicker
    cartChangedSelect: function cartChangedSelect() {
      setTimeout(function() {
        try {
          if (
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|WomensBestApp/i.test(navigator.userAgent)
          ) {
            $(".cart-item select").selectpicker("mobile");
            $(".wb-cart-rewards-item-container select").selectpicker("mobile");
          }
          $(".cart-item select").selectpicker("refresh");
          $(".wb-cart-rewards-item-container select").selectpicker("refresh");
        } catch (e) {
          //
        }
      }, 1);
    },


    // show/hide discount input
    discountClick: function discountClick() {
      $('.wb-cart-coupon-info').toggleClass('open');
      var checkbox = $('.wb-cart-discount__checkbox');
      checkbox.toggleClass('checked');
      $('.wb-discount-section').slideToggle(200, function () {
        if (checkbox.hasClass('checked')) {
          $('#wb-cart__discount-input').focus();
        }
      });
    },

    // submit discount code to checkout and check if discount is valid
    discountSubmit: function discountSubmit() {
      var discountUrl = "/checkout?discount=" + this.cartData.discount;
      var discountCheckClick = $("#wb-cart__discount-submit");

      if(this.cartData.discount == undefined || this.cartData.discount == ''){
        return;
      }

      this.cartData.discountLoading = true;
      this.cartData.removedDiscount = null;
      //console.log(discountUrl,this.cartData.discount);

      var self = this;

      axios({
        url: discountUrl,
        method: "get"
      })
        .then(function(response) {
          self.cartData.discountLoading = false;
          self.cartData.discountData = response.data;
          var discountValue = $(response.data)
            .contents()
            .find("[data-checkout-discount-amount-target]")
            .attr("data-checkout-discount-amount-target");
          var discountCodeType = $(response.data)
            .contents()
            .find("[data-discount-type]")
            .attr("data-discount-type");
          var errorMessage = $(response.data)
            .contents()
            .find("#error-for-reduction_code")
            .html();
          var warningMessage = $(response.data)
            .contents()
            .find(".notice__text")
            .html();

          self.cartData.discountType = discountCodeType;

          if (errorMessage) {
            self.cartData.SuccessMessageCheck = false;
            console.log("discount error" + errorMessage);
            self.cartData.dangerMessage = errorMessage;
            self.cartData.dangerMessageCheck = true;
            setTimeout(function() {
              self.cartData.dangerMessageCheck = false;
            }, 20000);
            self.genericEvent(
              "genericEvent",
              "Error Message",
              "cart_coupon",
              self.cartData.dangerMessage
            );
          }else if (warningMessage){
            self.cartData.SuccessMessageCheck = false;
            console.log("discount warning" + warningMessage);
            self.cartData.dangerMessage = warningMessage.replace('<strong>','"').replace('</strong>','"');
            self.cartData.dangerMessageCheck = true;
            setTimeout(function() {
              self.cartData.dangerMessageCheck = false;
            }, 20000);
            self.genericEvent(
              "genericEvent",
              "Error Message",
              "cart_coupon",
              self.cartData.dangerMessage
            );
          } else {
            if (discountCodeType == "percentage") {
              self.cartData.currentDiscount = self.cartData.discount;
              self.cartData.discountValue = parseInt(discountValue);
              self.cartData.dangerMessageCheck = false;
              self.cartData.discountPerc = Math.round(
                (self.cartData.discountValue * 100) / self.cartData.subtotal
              );
              self.cartData.SuccessMessageCheck = true;
              if (self.$store.state.base.currentLang == "en") {
                self.cartData.SuccessMessage =
                  "Discount code is added to your cart.";
              } else {
                self.cartData.SuccessMessage =
                  "Discount code is added to your cart.";
              }
              setTimeout(function() {
                self.cartData.SuccessMessageCheck = false;
              }, 20000);
              self.subtotalCal();
            } else if (discountCodeType == "fixed_amount") {
           //   console.log(discountCodeType);
              self.cartData.currentDiscount = self.cartData.discount;
              self.cartData.SuccessMessageCheck = true;
              if (self.$store.state.base.currentLang == "en") {
                self.cartData.SuccessMessage =
                  'Your discount code is a "Fixed Amount Discount Code" and will be listed in detail at the Checkout';
              } else {
                self.cartData.SuccessMessage =
                  'Your discount code is a "Fixed Amount Discount Code" and will be listed in detail at the Checkout';
              }
              setTimeout(function() {
                self.cartData.SuccessMessageCheck = false;
              }, 20000);
              self.subtotalCal();
            } else if (discountCodeType == "shipping") {
           //   console.log(discountCodeType);
              self.cartData.currentDiscount = self.cartData.discount;

              self.cartData.SuccessMessageCheck = true;
              if (self.$store.state.base.currentLang == "en") {
                self.cartData.SuccessMessage =
                  'Your discount code is a "Free Shipping Discount Code" and will be listed in detail at the Checkout';
              } else {
                self.cartData.SuccessMessage =
                  'Your discount code is a "Free Shipping Discount Code" and will be listed in detail at the Checkout';
              }
              setTimeout(function() {
                self.cartData.SuccessMessageCheck = false;
              }, 20000);
              self.subtotalCal();
            } else {
            //  console.log(discountCodeType);
              self.cartData.currentDiscount = self.cartData.discount;
              self.cartData.SuccessMessageCheck = true;
              if (self.$store.state.base.currentLang == "en") {
                self.cartData.SuccessMessage =
                  "Your discount code will be listed in detail at the Checkout";
              } else {
                self.cartData.SuccessMessage =
                  "Your discount code will be listed in detail at the Checkout";
              }
              setTimeout(function() {
                self.cartData.SuccessMessageCheck = false;
              }, 20000);
              self.subtotalCal();
            }
            self.genericEvent(
              "genericEvent",
              "Cart",
              "voucher redeem",
              self.cartData.currentDiscount
            );
          }
        })
        .catch(function(error) {
          self.cartData.discountLoading = false;
          console.log(error);
        });
    },

    //Check if Discount Code is already added to Checkout
    checkDiscountFromCart: function checkDiscountFromCart() {
      var self = this;
      var discountUrl = "/checkout";
      axios({
        url: discountUrl,
        method: "get"
      }).then(function(response) {
        var codeName = $(response.data).find("[data-discount-type]").find(".reduction-code__text").last().text();

        if (codeName === '') {
          codeName = Cookies.get('discount', {domain: '.womensbest.com'}) || '';
        }

        if (codeName != "") {
          $(".wb-cart-discount__checkbox").addClass("checked");
          $(".wb-discount-section").show(400);

          $("#wb-cart__discount-input").val(codeName);

          self.cartData.discount = codeName;

          //
          var discountUrl = "/checkout?discount=" + self.cartData.discount;
          var discountCheckClick = $("#wb-cart__discount-submit");

          self.cartData.removedDiscount = null;
          //console.log(discountUrl);

          axios({
            url: discountUrl,
            method: "get"
          }).then(function(response) {
            discountCheckClick.html('<i class="fa fa-angle-right"></i>');
            self.cartData.discountData = response.data;
            var discountValue = $(response.data)
              .contents()
              .find("[data-checkout-discount-amount-target]")
              .attr("data-checkout-discount-amount-target");
            var discountCodeType = $(response.data)
              .contents()
              .find("[data-discount-type]")
              .attr("data-discount-type");
            var errorMessage = $(response.data)
              .contents()
              .find("#error-for-reduction_code")
              .html();

            if (discountCodeType == "percentage") {
              self.cartData.currentDiscount = self.cartData.discount;
              self.cartData.discountValue = parseInt(discountValue);
              self.cartData.dangerMessageCheck = false;
              self.cartData.discountPerc = Math.round(
                (self.cartData.discountValue * 100) / self.cartData.subtotal
              );
              self.subtotalCal();
            } else if (discountCodeType == "fixed_amount") {
              //console.log(discountCodeType);

              self.subtotalCal();
            } else if (discountCodeType == "shipping") {
              //console.log(discountCodeType);

              self.subtotalCal();
            } else {
              //console.log(discountCodeType);

              self.subtotalCal();
            }
          });
        }
      });
    },

    // add cab product to cart
    cabAdd: function cabAdd(product, index, variant) {
      var self = this;
      var ids = [];
      var idCheck = false;
      var itemCount = 0;
      var varid;

      if(variant && !variant.available){
        return;
      }
      if(!product.available){
        return;
      }
      if(window.Cookies.get('special-offer') !== undefined){
        window.WBupdateCartNote('special-offer');
      }
      if (variant) {
        self.$store.commit('cabs/setCartCabSelected', variant);
        itemCount = 1;
      }

      product.variants.forEach(function(item, index) {
        if((typeof item.inventory_quantity === 'undefined' || item.inventory_quantity > 0) && itemCount == 0){
          varid = item.id;
          itemCount = 1;
        }
      });

      var quantity = 1;

      var totalbogo = 0;
      //for buy one get one free

      this.cartItems.filter(function(item) {
        if (item.product_id == 9705691716) {
          totalbogo += 1;
        }
      });

      if (product.id == 8105120769 && totalbogo < 1) {
        quantity = 2;
      }
      //end

      product.variants.filter(function(item, event) {
        if (idCheck == false) {
          if (item.id == self.$store.state.cabs.cartCabSelected.id) {
            idCheck = true;
          } else {
            idCheck = false;
          }
        }
      });

      if (idCheck == true) {
        varid = self.$store.state.cabs.cartCabSelected.id;
      } else {
      }

      axios
        .post("/cart/add.js", {
          quantity: quantity,
          id: varid
        })
        .then(function(response) {
          self.loadCart();

          self.eeAddToCart(product, index);
          document.dispatchEvent(new CustomEvent('wb:checkloadedcartItems'));
          document.dispatchEvent(new CustomEvent('wb:addtocarttracking', { detail: { sku: response.data.sku, qty: '1', title: response.data.title, prodID: response.data.product_id, variantID: response.data.variant_id } }));

        })
        .catch(function(error) {
          return console.log(error);
        });
    },
    // get Wishlist product handles
    wishlistProducts: function wishlistProducts() {

      this.cartData.cartWishlist = {};

      let subscription = window.WishlistKing.state.observeWishlist({wishlistId: 'mine'}).subscribe(wishlist => {
        let wishlistItems = new Map(wishlist.items
          .filter(item => item.product?.id)
          .reverse()
          .map((item, index) => [item.product?.id.toString(), index])
        );
        this.cartData.cartWishlistIds = Array.from(wishlistItems.keys());
        if (subscription) {
          subscription.unsubscribe();
        }
        this.getWishlistProduct();
      });
    },
    // get Wishlist products
    getWishlistProduct: function getWishlistProduct() {
      var self = this;
      var idsToUse = this.cartData.cartWishlistIds.slice(0,8);
      console.log("this.cartData.cartWishlistIds",this.idsToUse)
      var idList = idsToUse.join(',');

      window.axios('/search?view=iwish&q='+idList).then(function (response) {
        var resp = response;
        if(self.cartData.cartWishlist == resp.data){return;}
        self.cartData.cartWishlist = resp.data;
        setTimeout(function(){
          self.setUpDragSlide();
        },200);

        Vue.nextTick(function () {
          if (typeof window.equalHeightInstance !== 'undefined') {
            window.equalHeightInstance.update({ ignoreShopGrid: true, cache: true });
          }
        });

        return;
      });
    },

    isItemInStock: function(item) {
      if (!item) { return false; }
      // no check for bundles & giftcards
      if (item.product_type == 'Gift Cards') { return true; }
      if (item.properties && item.properties.bundleproperties) { return true; }
      if (!item.product_data || !item.product_data.variants) { return true; }
      var variant = item.product_data.variants.filter(function (variant) { return variant.sku === item.sku; })[0];
      // no check if variant not found or inventory quantity not present
      // TODO: inventory_quantity is not present in all shops
      if (!variant || typeof variant.inventory_quantity === 'undefined') { return true; }
      return variant.inventory_quantity > 0;
    },

    // remove discount code
    discountRemove: function discountRemove() {
      var removeDiscountUrl = "/checkout?discount=%20";

      axios({
        url: removeDiscountUrl,
        method: "get"
      }).then(function(response) {
        $("#wb-cart__discount-input").val("");
        self.cartData.removedDiscount = self.cartData.discount;
        self.cartData.discount = null;
        self.cartData.discountPerc = null;
        self.cartData.discountValue = null;
        self.totalCal();
        console.log("discount removed");
        self.cartData.SuccessMessageCheck = true;
        self.cartData.SuccessMessage = "Your discount code is now removed!";

        self.genericEvent(
          "genericEvent",
          "Cart",
          "voucher delete",
          self.cartData.removedDiscount
        );
        reloadPageIE();
      });
    },

    // customer can readd discount code after removing it
    readdDiscount: function readdDiscount() {
      var self = this;
      var discountUrl = "/checkout?discount=" + this.cartData.removedDiscount;
      var discountCheckClick = $("#wb-cart__discount-submit");

      discountCheckClick.html(
        '<img src="https://cdn.shopify.com/s/files/1/1812/3759/files/loadinground.gif?18110229494894053591"/>'
      );

      //console.log(discountUrl);

      this.cartData.discount = this.cartData.removedDiscount;

      axios({
        url: discountUrl,
        method: "get"
      }).then(function(response) {
        discountCheckClick.html('<i class="fa fa-angle-right"></i>');
        self.cartData.currentDiscount = self.cartData.discount;
        self.cartData.discountData = response.data;
        var discountValue = $(response.data)
          .contents()
          .find("[data-checkout-discount-amount-target]")
          .attr("data-checkout-discount-amount-target");
        //console.log(discountValue);
        self.cartData.discountValue = parseInt(discountValue);
        self.cartData.removedDiscount = null;
        self.cartData.discountPerc = Math.round(
          (self.cartData.discountValue * 100) / self.cartData.subtotal
        );
        self.cartData.SuccessMessage = "Discount code is added to your cart.";
        self.cartData.SuccessMessageCheck = true;

        setTimeout(function() {
          self.cartData.SuccessMessageCheck = false;
        }, 20000);
        self.subtotalCal();

        self.genericEvent(
          "genericEvent",
          "Cart",
          "voucher undo",
          self.cartData.currentDiscount
        );
      });
    },

    ///////////////////////////// TRACKING FUNCTIONS ///////////////////////////

    getProductCategoryString: function getProductCategoryString(
      type,
      variant1,
      variant2
    ) {
      if(variant1 == undefined || variant2 == undefined){
        return;
      }
      if (variant1 == "Default Title") {
        variant1 = "none";
        variant2 = "Ebook";
      } else if (variant1.match(/\d/) !== null) {
        variant2 = variant1;
        variant1 = "none";
      }
      return type + variant1 + "/" + variant2;
    },
    getProductVariantString: function getProductVariantString(variant1) {
      if(variant1 == undefined){
        return;
      }
      if (variant1 == "Default Title") {
        variant1 = "Ebook";
      }

      if (variant1.trim().length == 0) {
        variant1 = undefined;
      }

      return variant1;
    },
    getProductBadges: function getProductBadges(onsale, tags, available) {
      var badges = [];
      if (onsale) badges.push("sale");
      if (tags.indexOf("best-seller") !== -1) badges.push("bestseller");
      if (tags.indexOf("flavor") !== -1) badges.push("new flavor");
      if (/new(,|$)/.test(tags)) badges.push("new product");
      if (!available) badges.push("sold out");

      return badges.join(", ");
    },
    getUniqueId: function getUniqueId(id, variantid) {
      var uniqueid = ["shopify", id, variantid];
      return uniqueid.join("_");
    },
    genericEvent: function genericEvent(event, category, action, label) {
      dataLayer.push({
        event: event,
        category: category,
        action: action,
        label: label
      });
      //console.log(event,category,action,label);
    },
    onChangeTracking: function onChangeTracking(item) {
      var onChangedItem = item.product_data.variants.filter(function(item) {
        return item.id == this;
      }, item.variant_id);
      var onChangedVariantTitle = onChangedItem[0].title;
      var freeProduct = "";

      if (onChangedItem[0].price == 0) {
        var freeProduct = "Free ";
      } else {
        var freeProduct = "";
      }

      dataLayer.push({
        event: "selectionMade",
        selectedElement: '"' + onChangedVariantTitle + '"',
        productTitle: freeProduct + item.product_title
      });
    },
    eeRemoveCart: function eeRemoveCart(item, index, action) {
      var trackingCurrency = "";
      var trackingCurrency = this.$store.getters['base/currencyCode'];

      var freeProduct = "";
      if (item.line_price == 0) {
        var freeProduct = "Free ";
      } else {
        var freeProduct = "";
      }

      dataLayer.push({
        event: action,
        ecommerce: {
          currencyCode: trackingCurrency,
          remove: {
            products: [
              {
                name: freeProduct + item.product_title,
                id: item.sku,
                price: this.moneyformatTracking(item.line_price),
                brand: item.vendor,
                category: this.getProductCategoryString(
                  item.product_type,
                  item.variant_options[0],
                  item.variant_options[1]
                ),
                variant: this.getProductVariantString(
                  item.variant_options[0]
                ),
                quantity: item.quantity,
                metric2: "-" + this.moneyformatTracking(item.line_price),
                dimension6: index,
                dimension17: this.getProductBadges(
                  item.original_line_price > item.price,
                  item.product_data.tags,
                  true
                )
              }
            ]
          }
        }
      });
      //console.log(dataLayer);
    },
    eeAddToCart: function eeAddToCart(item, index) {
      var trackingCurrency = "";
      var idCheck = false;
      var optionOne = item.variants[0].option1;
      var optionTwo = item.variants[0].option2;
      var varid = item.variants[0].id;
      var i = index;
      var trackingCurrency = this.$store.getters['base/currencyCode'];

      var freeProduct = "";
      if (item.line_price == 0) {
        var freeProduct = "Free ";
      } else {
        var freeProduct = "";
      }

      var self = this;
      item.variants.filter(function(item, event) {
        if (idCheck == false) {
          if (item.id == self.$store.state.cabs.cartCabSelected.id) {
            idCheck = true;
          } else {
            idCheck = false;
          }
        }
      });

      if (idCheck == true) {
        optionOne = this.$store.state.cabs.cartCabSelected.option1;
        optionTwo = this.$store.state.cabs.cartCabSelected.option2;
        varid = this.$store.state.cabs.cartCabSelected.id;
      } else {
      }

      dataLayer.push({
        event: "addToCart",
        ecommerce: {
          currencyCode: trackingCurrency,
          add: {
            actionField: { list: "Cart" },
            products: [
              {
                name: freeProduct + item.title,
                id: item.sku,
                price: item.price,
                brand: item.vendor,
                category: this.getProductCategoryString(
                  item.type,
                  optionOne,
                  optionTwo
                ),
                variant: this.getProductVariantString(optionOne),
                quantity: item.quantity,
                dimension6: i,
                metric2: this.moneyformatTracking(item.price),
                dimension99: this.getUniqueId(item.id, varid),
                dimension17: this.getProductBadges(
                  item.variants[0].compare_at_price > item.price,
                  item.tags,
                  true
                ),
                position: ""
              }
            ]
          }
        }
      });
    },
    ///////////////////////////// TRACKING FUNCTIONS ende ///////////////////////////
    manageFreeProducts: function manageFreeProducts(
      productID,
      variantID,
      productID2,
      variantID2
    ) {
      var self = this;
      var promotionsInCart = this.freeProducts.length;

      if (this.cartData.total_price > 1000 && promotionsInCart == 0) {
        axios
          .post(
            "/cart/update.json",
            "updates[" + variantID + "]=1&updates[" + variantID2 + "]=1"
          )
          .then(function(response) {
            self.loadCart();
            reloadPageIE();
          })
          .catch(function(error) {
            return console.log(error);
          });
      } else if (this.cartData.total_price > 1000 && promotionsInCart > 2) {
        var itemIDs = [];
        this.freeProducts.forEach(function(item) {
          itemIDs.push(item.id);
        });

        if (itemIDs.length == 2) {
          axios
            .post(
              "/cart/update.json",
              "updates[" + itemIDs[0] + "]=0&updates[" + itemIDs[1] + "]=0"
            )
            .then(function(response) {
              self.loadCart();
              reloadPageIE();
            })
            .catch(function(error) {
              return console.log(error);
            });
        } else {
          axios
            .post("/cart/update.json", "updates[" + itemIDs[0] + "]=0")
            .then(function(response) {
              self.loadCart();
              reloadPageIE();
            })
            .catch(function(error) {
              return console.log(error);
            });
        }
      } else if (this.cartData.total_price < 1000 && promotionsInCart != 0) {
        var itemIDs = [];
        this.freeProducts.forEach(function(item) {
          itemIDs.push(item.id);
        });

        //console.log(itemIDs, itemIDs.length);
        if (itemIDs.length == 2) {
          axios
            .post(
              "/cart/update.json",
              "updates[" + itemIDs[0] + "]=0&updates[" + itemIDs[1] + "]=0"
            )
            .then(function(response) {
              self.loadCart();
              reloadPageIE();
            })
            .catch(function(error) {
              return console.log(error);
            });
        } else {
          axios
            .post("/cart/update.json", "updates[" + itemIDs[0] + "]=0")
            .then(function(response) {
              self.loadCart();
              reloadPageIE();
            })
            .catch(function(error) {
              return console.log(error);
            });
        }
      }

      //console.log(promotionsInCart);
    },
    bundleitemsName: function bundleitemsName(bundleitem) {
      var bundleName = bundleitem.replace().match(/(.*),(.*),(.*),(.*),(.*)/);

      return bundleName[1];
    },
    bundleitemsVairant: function bundleitemsVairant(bundleitem) {
      var bundleVariants = bundleitem
        .replace()
        .match(/(.*),(.*),(.*),(.*),(.*)/);
      return bundleVariants[3];
    },
    bundleitemsHandle: function bundleitemsHandle(bundleitem) {
      var bundleVariants = bundleitem
        .replace()
        .match(/(.*),(.*),(.*),(.*),(.*)/);
      return bundleVariants[2];
    },
    // put Rewards products from collection (json) into vue variable
    rewardproducts: function rewardproducts() {
      var self = this;
      axios({
        url: "/cart?view=rewards",
        method: "get"
      }).then(function(response) {

        var cartRewards = response.data;
        // remove all product variants which are not defined in the skus array
        if(cartRewards == undefined || (cartRewards.gold == undefined && cartRewards.regular == undefined)) {return;}
        if (cartRewards.skus) {
          cartRewards.rewards = cartRewards.rewards.filter(function (product) {
            return Boolean(product);
          }).map(function (product) {
            product.variants = product.variants.filter(function (variant) {
              return cartRewards.skus.indexOf(variant.sku) !== -1;
            });
            return product;
          }).filter(function (product) {
            return product.variants.length > 0;
          });
        }


        // remove all unavailable variants
        cartRewards.gold = cartRewards.gold.filter(function (product) {
          return Boolean(product);
        }).map(function (product) {
          product.variants = product.variants.filter(function (variant) {
            return variant.available && (typeof variant.inventory_quantity === 'undefined' || variant.inventory_quantity > 0);
          });
          return product;
        }).filter(function (product) {
          return product.variants.length > 0;
        });
        cartRewards.regular = cartRewards.regular.filter(function (product) {
          return Boolean(product);
        }).map(function (product) {
          product.variants = product.variants.filter(function (variant) {
            return variant.available && (typeof variant.inventory_quantity === 'undefined' || variant.inventory_quantity > 0);
          });
          return product;
        }).filter(function (product) {
          return product.variants.length > 0;
        });

        //console.log(cartRewards.rewards);
        self.cartData.cartRewards.gold = cartRewards.gold;
        self.cartData.cartRewards.regular = cartRewards.regular;

        self.cartData.cartRewards.gold.forEach(function(item,index){

          var itemIdToAdd = null;
          var variantFound = false;
          item.variants.forEach(function(variant, indexv) {
            if(variant.available && (typeof variant.inventory_quantity === 'undefined' || variant.inventory_quantity > 0) && variantFound == false){
              itemIdToAdd = variant.id;
              variantFound = true;
            }
          });

          self.cartData.cartRewardsSelected.gold.items[index] = itemIdToAdd;

        });
        self.cartData.cartRewards.regular.forEach(function(item,index){

          var itemIdToAdd = null;
          var variantFound = false;
      //    console.log("item.variants",item.variants)
          item.variants.forEach(function(variant, indexv) {
         //   console.log("variant",variant)
            if(variant.available && (typeof variant.inventory_quantity === 'undefined' || variant.inventory_quantity > 0) && variantFound == false){
              itemIdToAdd = variant.id;
              variantFound = true;
            }
          });

          self.cartData.cartRewardsSelected.regular.items[index] = itemIdToAdd;

        });

        self.rewardChangedSelect();
        //console.log(response.data);
      });
    },
    shouldShowRewards: function shouldShowRewards(type) {
    
      if ((typeof this.reChargeProducts === 'undefined' || this.reChargeProducts.length === 0) && ((this.cartData.cartRewards[type] && this.cartData.cartRewards[type].length > 0) || type === "regular"))
      {
        if (type === "regular") {
          const fashionItems = this.cartItems.filter(item => {
            if (!item?.product_data?.tags) {
              console.warn('Invalid item structure:', item);
              return false;
            }
           // return item.product_data.tags.includes('product_line_fashion') || item.product_data.tags.includes('product_line_fitness') ;
            return item.product_data.tags.includes('product_line_fashion')
          });
    
          return fashionItems.length > 0;
        }else{
          
          return true
        }
      }
      return false
      
    },
    fashionpromoproducts: function fashionpromoproducts() {
      if (this.settingFashionpromo !== '1') {
        return;
      }

      var self = this;

      if (self.fashionPromo.promoProducts.leggings.length > 0 && self.fashionPromo.promoProducts.tops.length > 0) {
        return;
      }

      axios.get("/cart?view=fashionpromo", { headers: { 'Cache-Control': 'no-cache, no-store','Pragma': 'no-cache', 'Expires': 0 } }).then(function(response) {

        self.fashionPromo.promoProducts = response.data;

        if (self.fashionPromo.leggingSelected.selected === -1 && self.fashionPromo.leggingSelected.selectedSize === -1) {
          var leggings = self.fashionPromoProducts.filter(function (product) {
            return self.validateFashionPromoProductLegging(product);
          });
          var legging;
          if (leggings.length > 0) {
            legging = leggings[0];
          }

          if (legging) {
            self.fashionPromo.promoProducts.leggings.forEach(function (product, index) {
              if (legging.product_data.id === product.id) {
                self.fashionPromo.leggingSelected.selected = index;
                product.variants.forEach(function (variant, index) {
                  if (legging.id === variant.id) {
                    self.fashionPromo.leggingSelected.selectedSize = index;
                  }
                });
              }
            });
          } else {
            self.fashionPromo.leggingSelected.selected = 0;
            self.fashionPromo.leggingSelected.selectedSize = -1;
          }

        }

        if (self.fashionPromo.topSelected.selected === -1 && self.fashionPromo.topSelected.selectedSize === -1) {
          var tops = self.fashionPromoProducts.filter(function (product) {
            return self.validateFashionPromoProductTop(product);
          });
          var top;
          if (tops.length > 0) {
            top = tops[0];
          }

          if (top) {
            self.fashionPromo.promoProducts.tops.forEach(function (product, index) {
              if (top.product_data.id === product.id) {
                self.fashionPromo.topSelected.selected = index;
                product.variants.forEach(function (variant, index) {
                  if (top.id === variant.id) {
                    self.fashionPromo.topSelected.selectedSize = index;
                  }
                });
              }
            });
          } else {
            self.fashionPromo.topSelected.selected = 0;
            self.fashionPromo.topSelected.selectedSize = -1;
          }
        }

        self.rewardChangedSelect();

      }).catch(function(error) {
        console.warn('Failed to load fashion promo products:', error);
      });
    },

    // validateRewardProduct: function validateRewardProduct(item){
    //   if(item.properties != null && item.properties.reward && item.properties.reward === true){
    //     var rewardItem = item;
    //     var rewardIndex = 0;
    //     if(this.cartData.cartRewards.rewards){
    //       this.cartData.cartRewards.rewards.forEach(function(item,index){
    //         if(rewardItem.product_id == item.id){
    //           rewardIndex = index;
    //         }
    //       });
    //       if(this.cartData.cartRewardsSelected.forceRemove !== true){
    //         if(this.cartData.cartRewardsSelected.radioIndex == null){
    //           this.cartData.cartRewardsSelected.radioIndex = rewardIndex;
    //           this.cartData.cartRewardsSelected.prevItem = rewardItem.id;
    //           //console.log(rewardItem.variant_options[0], rewardItem.id);
    //         }
    //       }
    //     }
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },

    validateFashionPromoProduct: function validateFashionPromoProduct(item){
      if (this.settingFashionpromo !== '1') {
        return false;
      }
      return this.validateFashionPromoProductLegging(item) || this.validateFashionPromoProductTop(item);
    },

    validateFashionPromoProductLegging: function validateFashionPromoProduct(item){
      return item.properties != null && ((item.properties._fsolegging && item.properties._fsolegging === true) || (item.properties.fsolegging && item.properties.fsolegging === true));
    },

    validateFashionPromoProductTop: function validateFashionPromoProduct(item){
      return item.properties != null && ((item.properties._fsobra && item.properties._fsobra === true) || (item.properties.fsobra && item.properties.fsobra === true));
    },
    validateRechargeProduct: function validateRechargeProduct(item){
      return item.properties != null && item.properties.shipping_interval_frequency && item.properties.shipping_interval_frequency !== undefined;
    },
    updateFashionPromo: function updateFashionPromo (variant, property, validator, noLoadCart) {
      if (!variant || !validator) {
        return Promise.resolve();
      }

      var self = this;

      function add () {
        var addedVariants = self.fashionPromoProducts.filter(function (item) { return validator(item) && variant.id === item.id });
        if (addedVariants.length === 0) {
          var properties = {};
          properties[property] = true;

          return axios
            .post("/cart/add.js", {
              quantity: 1,
              id: variant.id,
              properties: properties,
            }).then(function (response) {
              if (noLoadCart !== true) {
                self.loadCart()
              }
              return
            });
        } else {
          return Promise.resolve();
        }
      }

      var toDeleteRewardProducts = "";
      var axiosUpdateString = "";

      var axiosUpdateData = {};

      if (this.fashionPromoProducts.length > 0) {
        this.fashionPromoProducts.filter(function (item) { return validator(item) && variant.id !== item.id }).forEach(function(item,index){
          axiosUpdateData[item.id] = 0;
        });
      }

      if (Object.keys(axiosUpdateData).length > 0) {
        return axios
          .post("/cart/update.json", {
            updates: axiosUpdateData
          })
          .then(function (response) {
            return add();
          });
      } else {
        return add();
      }

    },
    fashionPromoReset: function fashionPromoReset() {
      var items = this.cartItems.filter(function (item) {
        return item.properties && (item.properties._fsolegging || item.properties._fsobra || item.properties.fsolegging || item.properties.fsobra);
      });

      this.fashionPromo.leggingSelected.selectedSize = -1;
      this.fashionPromo.topSelected.selectedSize = -1;
      if (items.length < 1) {return;}

      var data = {};
      items.forEach(function (item) {
        data[item.variant_id] = 0;
      });

      var self = this;

      return axios
        .post("/cart/update.json", {
          updates: data
        }).then(function () {
          self.loadCart();
          self.fashionPromo.leggingSelected.selectedSize = -1;
          self.fashionPromo.topSelected.selectedSize = -1;
        });
    },

    // refresh bootstrap-select selectpicker
    rewardChangedSelect: function rewardChangedSelect() {
      setTimeout(function(){
        if (
          /Android|webOS|iPhone|iPad|iPod|BlackBerry|WomensBestApp/i.test(navigator.userAgent)
        ) {
          $('div[select-index] .selectpicker').selectpicker("mobile");
        }
        $('div[select-index] .selectpicker').selectpicker();

        //console.log('select refresh');
      },1500);
    },
    refreshSelect: function refreshSelect() {
      setTimeout(function(){
        $('div[select-index] .selectpicker').selectpicker('refresh');
      },500);
    },
    rewardSelectChange: function rewardSelectChange(value, index,type){
      //console.log(value);
     // console.log('radio index: ',this.cartData.cartRewardsSelected[type].selected , value,this.cartData.cartRewardsSelected[type].selected == value);
      if(this.cartData.cartRewardsSelected[type].selected == value){
        this.isBusy = false
      }
      this.cartData.cartRewardsSelected[type].selected = value;
      this.cartData.cartRewardsSelected[type].radioIndex = index;
    },
    // reset reward
    rewardReset: function rewardReset() {
      this.cartData.cartRewardsSelected.gold.forceRemove = true;
      this.cartData.cartRewardsSelected.regular.forceRemove = true;
      var toDeleteRewardProducts = [];
      var axiosUpdateString;

      var self = this;

      if(this.rewardGoldProducts.length>0 || this.rewardRegularProducts.length>0){
        this.rewardGoldProducts.forEach(function(item,index){
          if (self.rewardGoldProducts.length == index + 1 && self.rewardRegularProducts.length ==0){
            toDeleteRewardProducts += '"' + item.id + '": 0';
          } else {
            toDeleteRewardProducts += '"' + item.id + '": 0, ';
          }
        });
        this.rewardRegularProducts.forEach(function(item,index){
          if (self.rewardRegularProducts.length == index + 1){
            toDeleteRewardProducts += '"' + item.id + '": 0';
          } else {
            toDeleteRewardProducts += '"' + item.id + '": 0, ';
          }
        });

        //console.log(toDeleteRewardProducts);
        var jsonString = '{"updates": {' + toDeleteRewardProducts + "}}";
        //console.log(jsonString);

        axiosUpdateString = JSON.parse(jsonString);

        axios({
          url: "/cart/update.json",
          method: "post",
          data: axiosUpdateString
        })
          .then(function(response) {
          //  console.log('free gift reset');

            self.loadCart();
            self.cartData.cartRewardsSelected.gold.selected = null;
            self.cartData.cartRewardsSelected.gold.radioIndex = null;
            self.cartData.cartRewardsSelected.gold.prevItem = null;
            self.cartData.cartRewardsSelected.regular.selected = null;
            self.cartData.cartRewardsSelected.regular.radioIndex = null;
            self.cartData.cartRewardsSelected.regular.prevItem = null;

          }).catch(function(error){
          console.log(error);
        });
      }
    },
    validateNoteTracking: function validateNoteTracking() {
      var cSpecialOffer = Cookies.get('SONoteTracking', {domain: '.womensbest.com'});
      if(cSpecialOffer !== undefined){
        this.noteTracking = cSpecialOffer;
      }
    },
    algoliaCartSubmitTracking: function algoliaCartSubmitTracking(){
      var variantIds = [];
      this.cartItems.forEach(function(item){
        variantIds.push(JSON.stringify(item.id))
      });
      if (this.$store.state.base.currentShop == 'me') { return; }
      
      var algoliaEventData = {
        userToken: window.getUserUuid(),
        index: window.algoliaIndex,
        eventName: 'CART: Product passed to checkout',
        objectIDs: variantIds,
        queryID: window.lastQueryID,
      };
      if(window.lastQueryID !== undefined){
      aa('convertedObjectIDs', algoliaEventData);
        }
    },

    // -------------------------------------------------------
    // UPSELL PROMO
    // -------------------------------------------------------

    initUpsellPromo: function initUpsellPromo() {
      var self = this;
      var el = document.getElementById('vue-app');
      if (!el) return;
      var handle = el.getAttribute('data-upsell-handle');
      if (!handle) return;

      self.upsellPromo.handle = handle;
      var variantFilter = el.getAttribute('data-upsell-variant-filter') || '';
      self.upsellPromo.variantFilter = variantFilter;

      axios({
        url: '/products/' + handle + '.js',
        method: 'get'
      }).then(function (response) {
        try {
          var product = response.data || null;
          if (!product || !Array.isArray(product.variants) || product.variants.length === 0) return;

          // If a variant filter is set, only show matching variants
          if (variantFilter) {
            product.variants = product.variants.filter(function (v) {
              return v.title.toLowerCase().indexOf(variantFilter.toLowerCase()) !== -1;
            });
            if (product.variants.length === 0) return;
          }

          self.upsellPromo.product = product;

          // Select first available variant
          var firstAvailable = product.variants.find(function (v) { return v.available; });
          if (firstAvailable) {
            self.upsellPromo.selectedVariantId = firstAvailable.id;
            self.upsellPromo.selectedVariant = firstAvailable;
          } else {
            console.log('Cart upsell promo: upsell product is sold out - replace with alternative');
            return;
          }

          self.checkUpsellInCart();

          // Init UI after Vue has rendered the v-if block
          self.$nextTick(function () {
            self.reinitUpsellUI();
          });
        } catch (e) {
          console.error('Cart upsell promo: error initializing', e);
        }
      }).catch(function (error) {
        console.error('Cart upsell promo: could not load product', handle, error);
      });
    },

    initUpsellCountdown: function initUpsellCountdown() {
      var self = this;
      var el = document.getElementById('vue-app');
      var countdownStr = el ? el.getAttribute('data-upsell-countdown') : null;
      if (!countdownStr) return;

      // Parse DD/MM/YYYY HH:MM:SS GMT+XXXX format
      var parts = countdownStr.match(/(\d{2})\/(\d{2})\/(\d{4})\s+(\d{2}:\d{2}:\d{2})\s*(.*)/);
      var targetDate;
      if (parts) {
        targetDate = new Date(parts[3] + '-' + parts[2] + '-' + parts[1] + 'T' + parts[4] + parts[5].replace('GMT', ''));
      } else {
        targetDate = new Date(countdownStr);
      }

      if (isNaN(targetDate.getTime())) return;

      // Clear any existing interval
      if (self._upsellCountdownInterval) {
        clearInterval(self._upsellCountdownInterval);
      }

      function pad(n) { return n < 10 ? '0' + n : n; }

      function updateCountdown() {
        var $el = document.getElementById('upsell-countdown');
        if (!$el) return;

        var now = Date.now();
        var diff = targetDate.getTime() - now;

        if (diff <= 0) {
          $el.textContent = '00:00:00';
          self.upsellPromo.timerActive = false;
          clearInterval(self._upsellCountdownInterval);
          return;
        }

        self.upsellPromo.timerActive = true;
        var totalSeconds = Math.floor(diff / 1000);
        var totalHours = Math.floor(totalSeconds / 3600);
        var minutes = Math.floor((totalSeconds % 3600) / 60);
        var seconds = totalSeconds % 60;

        var text = pad(totalHours) + ':' + pad(minutes) + ':' + pad(seconds);
        $el.textContent = text;
      }

      // Wait for the DOM element to exist, then start
      var attempts = 0;
      var waitForEl = setInterval(function () {
        attempts++;
        var $el = document.getElementById('upsell-countdown');
        if ($el) {
          clearInterval(waitForEl);
          updateCountdown();
          self._upsellCountdownInterval = setInterval(updateCountdown, 1000);
        } else if (attempts > 20) {
          clearInterval(waitForEl);
        }
      }, 100);
    },

    initUpsellSelectpicker: function initUpsellSelectpicker() {
      var self = this;
      var $select = $('.wb-upsell-variant-select');
      if (!$select.length) return;

      // Set initial value
      $select.val(self.upsellPromo.selectedVariantId);
      $select.selectpicker('render');

      // Bind change event
      $select.off('changed.bs.select.upsell').on('changed.bs.select.upsell', function () {
        var newId = parseInt($(this).val());
        if (!newId || !self.upsellPromo.product) return;
        self.upsellPromo.selectedVariantId = newId;
        var selected = self.upsellPromo.product.variants.find(function (v) {
          return v.id === newId;
        });
        if (selected) {
          self.upsellPromo.selectedVariant = selected;
        }
      });
    },

    checkUpsellInCart: function checkUpsellInCart() {
      if (!this.upsellPromo.product) return;
      var productId = this.upsellPromo.product.id;
      this.upsellPromo.isInCart = this.cartItems.some(function (item) {
        return item.product_id === productId;
      });
    },

    reinitUpsellUI: function reinitUpsellUI() {
      this.initUpsellSelectpicker();
      this.initUpsellCountdown();
      if (window.productReviewsInstance) {
        window.productReviewsInstance.updateCollection();
      }
    },

    addUpsellPromo: function addUpsellPromo() {
      var variantId = parseInt(this.upsellPromo.selectedVariantId);
      if (!variantId || this.upsellPromo.adding) return;
      var self = this;
      self.upsellPromo.adding = true;

      axios.post('/cart/add.json', {
        items: [{
          id: variantId,
          quantity: 1
        }]
      }).then(function () {
        self.upsellPromo.adding = false;

        // GTM tracking
        if (typeof window.callGTMTracking === 'function') {
          window.callGTMTracking('upsell-feature-cart');
        }

        self.loadCart();
      }).catch(function (error) {
        console.error('Cart upsell promo: could not add to cart', error);
        self.upsellPromo.adding = false;
      });
    },

  },
  watch: {
    "nutritionProductsCount": function (newVal, oldVal) {
     // console.log("newVal",newVal);
     // console.log("this.strongWomanEraBook",this.strongWomanEraBook?.length);
      var currentShop = this.$store?.state?.base?.currentShop;
     
        return
    
      if (newVal >= 3 && this.strongWomanEraBook?.length == 0) {
        //console.log('Add free Strong Woman Era book because user has', newVal, 'nutrition products');

        const bookVariantId = 51819053187401;
        const bookProductId = 9566115823945;

     
        axios.post("/cart/add.js", {
          quantity: 1,
          id: bookVariantId,
          properties: {
            "_giftpromo": true
          }
        })
          .then(response => {
           // console.log('Successfully added Strong Woman Era book to cart', response.data);
            this.loadCart();
          })
          .catch(error => {
            console.error('Error adding Strong Woman Era book to cart:', error);
          });
      } else if (newVal < 3 && this.strongWomanEraBook.length > 0) {

      //  console.log('Remove Strong Woman Era book because user has only', newVal, 'nutrition products');

        
        const updateData = {};
        this.strongWomanEraBook.forEach(item => {
          updateData[item.variant_id] = 0;
        });

        if (Object.keys(updateData).length > 0) {
          axios.post("/cart/update.json", {
            updates: updateData
          })
            .then(response => {
              console.log('Successfully removed Strong Woman Era book from cart');
              this.loadCart();
            })
            .catch(error => {
              console.error('Error removing Strong Woman Era book from cart:', error);
            });
        }
      }
    },
    "cartItems": function () {
      this.checkUpsellInCart();
    },
    "upsellPromo.isInCart": function (newVal, oldVal) {
      if (newVal === false && this.upsellPromo.product) {
        // Block appeared or reappeared — re-init selectpicker and countdown on new DOM
        var self = this;
        self.$nextTick(function () {
          self.reinitUpsellUI();
        });
      }
    },
    "cartType": function (newVal, oldVal){
      //console.log('carttype change', newVal)
      var update = "attributes[carttype]="+newVal;
      if (typeof AppUserAgentDetected !== 'undefined' && AppUserAgentDetected) {
        update += '&attributes[app]=true';
        if (typeof AppUserAgentVersion !== 'undefined' && AppUserAgentVersion) {
          update += '&attributes[app_version]=' + AppUserAgentVersion;
        }
      } else if (typeof vuestore !== 'undefined' && typeof vuestore?.state?.cart?.attributes?.app !== 'undefined') {
        update += '&attributes[app]=&attributes[app_version]='; 
      }
      axios.post('/cart/update.js', update);
    },
    "cartError": function cartDataTotal_price(newVal, oldVal) {
      if (this._cartErrorTimeout) {
        clearTimeout(this._cartErrorTimeout);
        this.cartErrorTimeout = null;
      }
      var self = this;
      this._cartErrorTimeout = setTimeout(function() {
        self.cartError = null;
        self._cartErrorTimeout = null;
      }, 5000);
    },
    "cartData.cartCount":  function (newVal, oldVal) {
      if (oldVal < 1) {
        // update smile bp when cart was empty initially
        this.$nextTick(() => this.smileBPCalc());

        this.$nextTick(() => this.showHideFixedCheckout());

        // Cart went from empty to having items — init upsell UI if product loaded
        if (newVal > 0 && this.upsellPromo.product && !this.upsellPromo.isInCart) {
          var self = this;
          self.$nextTick(function () {
            self.reinitUpsellUI();
          });
        }
      }
    },
    "cartData.subtotal": function cartDataTotal_price(newVal, oldVal) {
      //console.log('total changes to'+ newVal, oldVal);
      //reset if value is lower
      if(this.settingFashionpromo !== '1'){
        return;
      }
      if(newVal < parseInt(this.settingFashionpromoValue) || this.fashionProducts.length == 0) {
        this.fashionPromoReset()
      }
      if (true) {
        var self = this;
        //console.log(newVal);
        self.updateFashionPromo(self.fashionPromoSelectedLeggingSize, '_fsolegging', self.validateFashionPromoProductLegging, true).then(function () {
          return self.updateFashionPromo(self.fashionPromoSelectedTopSize, '_fsobra', self.validateFashionPromoProductTop);
        });
      }
    },
    "cartData.cartRewardsSelected.gold.radioIndex": function rewardsSelectedChange(newVal, oldVal) {
      //console.log('selected change ', oldVal,newVal,this.standartProducts);
      if(this.cartData.cartRewardsSelected.gold.forceRemove !== true){
        this.cartData.cartRewardsSelected.gold.selected = this.cartData.cartRewardsSelected.gold.items[newVal];
      }
    },
    "cartData.cartRewardsSelected.regular.radioIndex": function rewardsSelectedChange(newVal, oldVal) {
      //console.log('selected change ', oldVal,newVal,this.standartProducts);
      if(this.cartData.cartRewardsSelected.regular.forceRemove !== true){
        this.cartData.cartRewardsSelected.regular.selected = this.cartData.cartRewardsSelected.regular.items[newVal];
      }
    },
    "cartData.cartRewardsSelected.gold.items": function rewardsItemsChange(newVal, oldVal) {
      //console.log('reward change ',oldVal,newVal,this.standartProducts);
      if(this.cartData.cartRewardsSelected.gold.forceRemove !== true){
        this.cartData.cartRewardsSelected.gold.selected = newVal[this.cartData.cartRewardsSelected.gold.radioIndex];
      }
    },
    "cartData.cartRewardsSelected.regular.items": function rewardsItemsChange(newVal, oldVal) {
      //console.log('reward change ',oldVal,newVal,this.standartProducts);
      if(this.cartData.cartRewardsSelected.regular.forceRemove !== true){
        this.cartData.cartRewardsSelected.regular.selected = newVal[this.cartData.cartRewardsSelected.regular.radioIndex];
      }
    },
    "cartData.cartRewardsSelected.gold.selected": function rewardsSelectedAdd(newVal, oldVal) {
      var self = this;
      // todo: add reward items as computed variable - find the item which needs to be removed and remove it
     // console.log("this.cartData.cartRewardsSelected.forceRemove",this.cartData.cartRewardsSelected.gold.forceRemove)
      if(this.cartData.cartRewardsSelected.gold.forceRemove !== true ){

        var toDeleteRewardProducts = [];

        var axiosUpdateString;
        if(this.cartData.cartRewardsSelected.gold.disableReward == false){
          this.cartData.cartRewardsSelected.gold.disableReward = true;
 
          if(this.rewardGoldProducts.length>0){
            //console.log('remove',oldVal);
            //console.log('add',newVal);

            // this.cartData.cartRewardsSelected.selected = this.rewardProducts[0].id;
            this.rewardGoldProducts.forEach(function(item,index){
              if(self.cartData.cartRewardsSelected.gold.prevItem != null){
                self.cartData.cartRewardsSelected.gold.selected = self.cartData.cartRewardsSelected.gold.prevItem;
              }
            //  console.log("self.rewardGoldProducts.length",self.rewardGoldProducts.length)
              if (self.rewardGoldProducts.length == index + 1) {
                toDeleteRewardProducts += '"' + item.id + '": 0';
              } else {
                toDeleteRewardProducts += '"' + item.id + '": 0, ';
              }
            });
          //  console.log(toDeleteRewardProducts);
            var jsonString = '{"updates": {' + toDeleteRewardProducts + "}}";
            //console.log(jsonString);

            axiosUpdateString = JSON.parse(jsonString);

            axios({
              url: "/cart/update.json",
              method: "post",
              data: axiosUpdateString
            })
              .then(function(response) {
                

                if(self.cartData.cartRewardsSelected.gold.selected !== null){

                  var postUrl = "/cart/add.json";
                  var postQTY = 1;
                  self.standartProducts.filter(function(item){
                 // console.log("item",item)
                    if(item.id == self.cartData.cartRewardsSelected.gold.selected){
                      return postQTY = 0;
                    }
                  });

                  var axiosData = {
                    'id': self.cartData.cartRewardsSelected.gold.selected,
                    'quantity': postQTY,
                    'properties': {
                      '_reward': true
                    }
                  };

                  axios
                    .post(postUrl, axiosData).then(function(response) {
                  //  console.log("response",response);
                    self.cartData.cartRewardsSelected.gold.prevItem = null;
                    self.loadCart().finally(function(){
                    });

                    // GTM tracking
                    //window.callGTMTracking('cart-reward-gold');

                    setTimeout(function(){
                      self.cartData.cartRewardsSelected.gold.disableReward = false;
                    },500);

                  }).catch(function(error){
                    console.log(error);
                    setTimeout(function(){
                      self.cartData.cartRewardsSelected.gold.disableReward = false;
                    },500);
                  });

                  $('div[select-index="'+self.cartData.cartRewardsSelected.gold.radioIndex+'"] .selectpicker').val(self.cartData.cartRewardsSelected.gold.selected);
                  $('div[select-index="'+self.cartData.cartRewardsSelected.gold.radioIndex+'"] .selectpicker').selectpicker('refresh');

                }else {
                }
                //console.log('delete free products');
              })
              .catch(function(error) {
                return console.log(error);
              });

          }else{

            if(this.cartData.cartRewardsSelected.gold.selected !== null){
              axios
                .post("/cart/add.js", {
                  quantity: 1,
                  id: this.cartData.cartRewardsSelected.gold.selected,
                  properties: {
                    '_reward': true
                  }
                }).then(function(response) {
                self.cartData.cartRewardsSelected.gold.prevItem = null;
                self.loadCart();
             //  console.log('item added',response);
            //    console.log('post ajax 2 ', oldVal,newVal,self.standartProducts, self.rewardGoldProducts);

                // GTM tracking
                //window.callGTMTracking('cart-reward-gold');

                setTimeout(function(){
                  self.cartData.cartRewardsSelected.gold.disableReward = false;
                },500);
              }).catch(function(error){
                console.log(error);
                setTimeout(function(){
                  self.cartData.cartRewardsSelected.gold.disableReward = false;
                },500);
              });
            }else {
            }
            // console.log('testtest');
          }
        }
      }
    //  console.log('post ajax 3', oldVal,newVal,self.standartProducts, self.rewardGoldProducts);
    },
    "cartData.cartRewardsSelected.regular.selected": function rewardsSelectedAdd(newVal, oldVal) {
      var self = this;
      // todo: add reward items as computed variable - find the item which needs to be removed and remove it

      if(this.cartData.cartRewardsSelected.regular.forceRemove !== true ){

        var toDeleteRewardProducts = [];

        var axiosUpdateString;
    
        if(this.cartData.cartRewardsSelected.regular.disableReward == false){
          this.cartData.cartRewardsSelected.regular.disableReward = true;
         
          if(this.rewardRegularProducts.length>0){
            //console.log('remove',oldVal);
            //console.log('add',newVal);

            // this.cartData.cartRewardsSelected.selected = this.rewardProducts[0].id;
        //  console.log('this.rewardRegularProducts',this.rewardRegularProducts)
            this.rewardRegularProducts.forEach(function(item,index){
              if(self.cartData.cartRewardsSelected.regular.prevItem != null){
                self.cartData.cartRewardsSelected.regular.selected = self.cartData.cartRewardsSelected.regular.prevItem;
              }
        
              if (self.rewardRegularProducts.length == index + 1) {
                toDeleteRewardProducts += '"' + item.id + '": 0';
              } else {
                toDeleteRewardProducts += '"' + item.id + '": 0, ';
              }
            });
          //  console.log(toDeleteRewardProducts);
            var jsonString = '{"updates": {' + toDeleteRewardProducts + "}}";
            //console.log(jsonString);

            axiosUpdateString = JSON.parse(jsonString);

            axios({
              url: "/cart/update.json",
              method: "post",
              data: axiosUpdateString
            })
              .then(function(response) {

              //  console.log('reward items deleted' , self.cartData.cartRewardsSelected.regular.selected , 'added');

                if(self.cartData.cartRewardsSelected.regular.selected !== null){

                  var postUrl = "/cart/add.json";
                  var postQTY = 1;
                  self.standartProducts.filter(function(item){
                  //  console.log("item",item)
                    if(item.id == self.cartData.cartRewardsSelected.regular.selected){
                      return postQTY = 0;
                    }
                  });

                  var axiosData = {
                    'id': self.cartData.cartRewardsSelected.regular.selected,
                    'quantity': postQTY,
                    'properties': {
                      '_regular_reward': true
                    }
                  };

                  axios
                    .post(postUrl, axiosData).then(function(response) {
                    self.cartData.cartRewardsSelected.regular.prevItem = null;
                    self.loadCart().finally(function(){
                    });
                  //  console.log('reward item added');

                    // GTM tracking
                    //window.callGTMTracking('cart-reward-regular');

                    setTimeout(function(){
                      self.cartData.cartRewardsSelected.regular.disableReward = false;
                    },500);

                  }).catch(function(error){
                    console.log(error);
                    setTimeout(function(){
                      self.cartData.cartRewardsSelected.regular.disableReward = false;
                    },500);
                  });

                  $('div[select-index="'+self.cartData.cartRewardsSelected.regular.radioIndex+'"] .selectpicker').val(self.cartData.cartRewardsSelected.regular.selected);
                  $('div[select-index="'+self.cartData.cartRewardsSelected.regular.radioIndex+'"] .selectpicker').selectpicker('refresh');

                }else {
                }
                //console.log('delete free products');
              })
              .catch(function(error) {
                return console.log(error);
              });

          }else{

            if(this.cartData.cartRewardsSelected.regular.selected !== null){
              axios
                .post("/cart/add.js", {
                  quantity: 1,
                  id: this.cartData.cartRewardsSelected.regular.selected,
                  properties: {
                    '_regular_reward': true
                  }
                }).then(function(response) {
                self.cartData.cartRewardsSelected.regular.prevItem = null;
                self.loadCart();
              //  console.log('item added',response);
               // console.log('post ajax 2 ', oldVal,newVal,self.standartProducts, self.rewardRegularProducts);

                // GTM tracking
                //window.callGTMTracking('cart-reward-regular');

                setTimeout(function(){
                  self.cartData.cartRewardsSelected.regular.disableReward = false;
                },500);
              }).catch(function(error){
                console.log(error);
                setTimeout(function(){
                  self.cartData.cartRewardsSelected.regular.disableReward = false;
                },500);
              });
            }else {
            }
            // console.log('testtest');
          }
        }
      }
    //  console.log('post ajax 3', oldVal,newVal,self.standartProducts, self.rewardRegularProducts);
    },
    isBusy: function isBusy(newVal, oldVal) {
      if (oldVal == true && newVal == false) {
        this.cartChangedSelect();
        //this.checkPriceFreeProducts();
        //this.manageFreeProducts(52992180237,422670663693,1593200345101,1593200246797);
      }
      //remove height flicker from pricing section
      if (this.isBusy == true) {
        var elementHeight = $(".cart_background").height();
        $(".cart_background").css("height", elementHeight);
        //console.log('busy changes'+ elementHeight);
      } else {
        $(".cart_background").css("height", "auto");
      }

    },
    fashionPromoSelectedLegging:  function fashionPromoSelectedLegging() {
      this.refreshSelect();
    },
    fashionPromoSelectedTop: function fashionPromoSelectedTop() {
      this.refreshSelect();
    },
    fashionPromoSelectedLeggingSize: function fashionPromoSelectedLeggingSize() {
      this.updateFashionPromo(this.fashionPromoSelectedLeggingSize, '_fsolegging', this.validateFashionPromoProductLegging);
    },
    fashionPromoSelectedTopSize: function fashionPromoSelectedTopSize(oldVariant, newVariant) {
      var self = this;
      setTimeout(function() {
        self.updateFashionPromo(self.fashionPromoSelectedTopSize, '_fsobra', self.validateFashionPromoProductTop);
      }, oldVariant && !newVariant ? 1000 : 0);
    },
    freePorridgeProducts: function freePorridgeProducts(newVal, oldVal) {
      var self = this;
      if(newVal.length > 0 && this.porridgeProducts.length == 0 && false){
        var variantID = '';

      if(currentShop == 'de'){
        variantID = '47979651432789';
      }else if(currentShop == 'at'){
        variantID = '47979651400021';
      }else if(currentShop == 'fr'){
        variantID = '48164697571665';
      }else if(currentShop == 'au'){
        variantID = '47979638784341';
      }else if(currentShop == 'ca'){
        variantID = '48052652933444';
      }else if(currentShop == 'ie'){
        variantID = '47475598721355';
      }else if(currentShop == 'uk'){
        variantID = '49606868664649';
      }else if(currentShop == 'eu'){
        variantID = '47987191677251';
      }else if(currentShop == 'us'){
        variantID = '47775185076571';
      }else{
        variantID = '48407759978831';
      }

          //this.addProductClick(variantID);
      }
    }
  },

  computed: {
    threefortwo: function threefortwo() {
      // Define the list of promotion SKUs
      const promoSkus = [
        '9010128074440', '9010128074488', '9010128002306', '840023307386',
        '9010128074518', '9010128105557', '9010128204755', '9010128010813',
        '840023302978', '9010128042128', '9010128105892', '9010128040414',
        '840023302954', '9010128105533', '840023304965', '840023300493',
        '9010128106493', '840023300530', '840023304880', '9010128166503',
        '9010128105526', '840023303944'
      ];

    
      if (this.cartData.cartCount <= 0) {
        return false;
      }

//console.log('this.standartProducts',this.standartProducts)
      const chocolatePromoProducts = this.standartProducts.filter(item => {
        const hasTag = item.product_data.tags.includes('vitamins3for2');
     /*   const hasSku = promoSkus.includes(item.sku);
        return hasTag && hasSku;*/
        return hasTag ;
      });


      if (chocolatePromoProducts.length === 0) {
        return false;
      }

    
      const chocolatePromoQuantity = chocolatePromoProducts.reduce(
        (sum, item) => sum + item.quantity,
        0
      );

 
      return chocolatePromoQuantity % 3 !== 0;
    },
    ...Vuex.mapGetters("base", ["moneyformat", "moneyPercFormat"]),
    currency: function() {
      return this.$store.getters['base/currencyCode'];
    },
    // checks if isBusy true or false and sets the opacity for a smooth loading
    cartStyle: function cartStyle() {
      return this.isBusy
        ? "opacity: 0.35;transition: all 0.15s;cursor:progress"
        : "opacity: 1;transition: all 0.15s;";
    },
    // checks if isBusy true or false and sets the opacity to 0 or 1 for a smooth loading
    cartPriceStyle: function cartPriceStyle() {
      return this.isBusy
        ? "opacity: 0.0;transition: all 0.05s;"
        : "opacity: 1;transition: all 0.15s;";
    },

    // firter cartItems array for free items
    freeProducts: function freeProducts() {
      var self = this;
      return this.cartItems.filter(function(item) {
        if(!self.validateRewardProduct(item) && !self.validateFashionPromoProduct(item)){
          return item.line_price === 0;
        }
      });
    },

    // firter cartItems array for priced items
    standartProducts: function standartProducts() {
      var self = this;
      return this.cartItems.filter(function(item) {
        if(!self.validateRewardProduct(item) && !self.validateFashionPromoProduct(item)){
          return item.line_price !== 0;
        }
      });
    },
    strongWomanEraBook: function strongWomanEraBook(){
      return this.cartItems.filter(function(item) {
        if(item.product_data.tags.indexOf('strong-women-era') != -1){
          return item;
        }
      });
    },
    // firter cartItems array for priced items
    bundleProducts: function bundleProducts() {
      var self = this;
      return this.cartItems.filter(function(item) {
        if(!self.validateRewardProduct(item) && !self.validateFashionPromoProduct(item)){
          return item.line_price !== 0 && item.properties != undefined && item.properties.bundleproducts != undefined;
        }
      });
    },
    cartCount: function cartCount() {
      var self = this;
      var cartCount = 0;
      this.cartItems.forEach(function(item) {
        cartCount += item.quantity;
      });
      return cartCount;
    },

    freesportsbra: function freesportsbra() {
      return false;
      var self = this;
      var hasbra = false;
      this.freeProducts.forEach(function(item) {
        if(item.handle=="gift-sportswear-3"){
          hasbra = true;
        }
      });
      return hasbra;
    },
    // firter cartItems array for priced items
    reChargeProducts: function reChargeProducts() {
      var self = this;
      return this.cartItems.filter(function(item) {
        if(self.validateRechargeProduct(item) && !self.validateRewardProduct(item) && !self.validateFashionPromoProduct(item)){
          return item;
        }
      });
    },
    nutritionProductsCount: function nutritionProductsCount() {
      return this.cartItems.filter(function(item) {
        try {
    
          const isNutrition = typeof item.product_data !== 'undefined' &&
            item.product_data.tags.indexOf(' product_line_fitness') != -1;

            
          const isNotGift = !(item.properties &&
            (item.properties._giftpromo === true ||
              item.properties.giftpromo === true ||
              item.properties._reward === true ||
              item.properties._regular_reward === true ||
              item.properties.reward === true 
            ));
          return isNutrition && isNotGift;
        } catch (e) {
          console.log(item);
          return false;
        }
      }).reduce(function(sum, item) {
        return sum + (item.quantity || 0);
      }, 0);
    },

    nutritionProducts: function nutritionProducts() {
      return this.cartItems.filter(function(item) {
        try {
          return typeof item.product_data !== 'undefined' && item.product_data.tags.indexOf(' product_line_fitness')!= -1;
        } catch (e)  {
          console.log(item);
        }
      });
    },
    fashionProducts_gift: function fashionProducts() {
      return this.cartItems.filter(function(item) {
        try {
          return typeof item.product_data !== 'undefined' && item.product_data.tags.indexOf(' product_line_fashion')!= -1;
        } catch (e)  {
          console.log(item);
        }
      });
    },


    // firter cartItems array for flatrate item
    healthsupplements: function healthsupplements() {
      let all= this.cartItems.filter(function(item) {
        return typeof item.product_data !== 'undefined' && item.product_data.tags.indexOf(' daily-wellness') != -1;
      });
      return this.cartData.cartCount > 0 && all.length > 0 && all.filter(function (line_item) { return (line_item.product_data.tags.indexOf(' daily-wellness') != -1) }).reduce(function (sum, line_item) { return sum + line_item.quantity; }, 0)  % 2 !== 0
    },
    bogoProducts: function bogoProducts() {
      return this.cartItems.filter(function(item) {
        return typeof item.product_data !== 'undefined' && item.product_data.tags.indexOf(' three-for-2') != -1;
      });
    },
    // firter cartItems array for flatrate item
    flatrateProducts: function flatrateProducts() {
      var self = this;
      return this.cartItems.filter(function(item) {
        if(!self.validateRewardProduct(item) && !self.validateFashionPromoProduct(item)){
          return item.line_price !== 0 && item.product_data.tags.indexOf('flatrate') != -1;
        }
      });
    },
    offerSubtotal: function offerSubtotal() {
      return this.cartItems.reduce(function(total, item) {
        if (true) {
          return total + item.original_line_price;
        } else {
          return total + item.line_price;
        }
      }, 0);
    },
    newReleasesProducts: function newReleasesProducts() {
      return this.cartItems.filter(function(item) {
        if(/new(,|$)/.test(item.product_data.tags)){
          return item;
        }
      });
    },
    defineProducts: function defineProducts() {
      return this.cartItems.filter(function(item) {
        if(item.product_data.tags.indexOf('define') != -1){
          return item;
        }
      });
    },
    freePorridgeProducts: function freePorridgeProducts() {
      return this.cartItems.filter(function(item) {
        if(item.product_data.tags.indexOf('freeporridge') != -1){
          return item;
        }
      });
    },
    porridgeProducts: function porridgeProducts() {
      return this.cartItems.filter(function(item) {
        if(item.product_data.handle == 'smart-protein-porridge'){
          return item;
        }
      });
    },
    upsellPromoHidden: function upsellPromoHidden() {
      if (this.$store.state.base.currentShop === 'com') {
        try {
          var ipShopCache = GeoRedirect.getIpShopCache();
          if (ipShopCache && ipShopCache.country_code === 'MX') return true;
        } catch (e) {}
      }
      return this.$store.state.base.currentShop === 'us' && this.fashionProducts.length > 0;
    },
    fashionProducts: function fashionProducts() {
      return this.cartItems.filter(function(item) {
        if(item.product_data.tags.indexOf('product_line_fashion') != -1 && (item.properties._fsolegging != true || item.properties.fsolegging != true)){
          return item;
        }
      });
    },
    // Deal of the day 10 products
    dealday10: function dealday10() {
      return this.cartItems.filter(function(item) {
        if(item.product_data.tags.indexOf('deal-of-the-day-10') != -1){
          return item;
        }
      });
    },
    // firter cartItems array for priced items
    rewardGoldProducts: function rewardGoldProducts() {
      var self = this;
      return this.cartItems.filter(function(item) {
        if(self.validateRewardProduct(item)){
          if(item.properties._reward == true || item.properties.reward == true ){
            return item;
          }
        }
      });
    },
    rewardRegularProducts: function rewardRegularProducts() {
      var self = this;
      return this.cartItems.filter(function(item) {
        if(self.validateRewardProduct(item)){
          if(item.properties._regular_reward == true){
            return item;
          }
        }
      });
    },
    freeGifts: function() {
      return new CartFreeGifts(
        this.$store.state.base.currentShop, 
        this.$store.state.base.currentLang, 
        this.$store.state.base.hasCustomer,
      );
    },
    gifts: function () {
      return this.freeGifts.gifts;
    },
    freeShippingFrom: function() {
      return this.freeGifts.freeShippingFrom;
    },
    freeExpressShippingFrom: function() {
      return this.freeGifts.freeExpressShippingFrom;
    },
    // firter cartItems array for priced items
    scriptPromoSavings: function scriptPromo() {
      var scriptPromoName = false;
      this.cartItems.filter(function(item) {
        if(item.line_level_discount_allocations[0] && item.line_level_discount_allocations[0].discount_application.title){
          var tmp = item.line_level_discount_allocations[0].discount_application.title.split('|')[1];
          if (tmp) {
            scriptPromoName = tmp.match(/\d+/)[0]*100;
          }
        }
      });
      return scriptPromoName;
    },

    // firter cartItems array for priced items
    fashionPromoProducts: function fashionPromoProducts() {
      var self = this;
      return self.cartItems.filter(function(item) {
        if(self.validateFashionPromoProduct(item)){
          return item;
        }
      });
    },
    fashionPromoSelectedLegging: function fashionPromoSelectedLegging() {
      return this.fashionPromo.promoProducts.leggings[this.fashionPromo.leggingSelected.selected]
    },
    fashionPromoSelectedTop: function fashionPromoSelectedTop() {
      return this.fashionPromo.promoProducts.tops[this.fashionPromo.topSelected.selected]
    },
    fashionPromoSelectedLeggingSize: function fashionPromoSelectedLeggingSize() {
      if (!this.fashionPromoSelectedLegging || typeof this.fashionPromoSelectedLegging.variants === 'undefined') {
        return null;
      }
      return this.fashionPromoSelectedLegging.variants[this.fashionPromo.leggingSelected.selectedSize]
    },
    fashionPromoSelectedTopSize: function fashionPromoSelectedTopSize() {
      if (!this.fashionPromoSelectedTop || typeof this.fashionPromoSelectedTop.variants === 'undefined') {
        return null;
      }
      return this.fashionPromoSelectedTop.variants[this.fashionPromo.topSelected.selectedSize]
    },
 
  },
});

var el = document.getElementById('vue-app');

// Global error handler for Vue cart errors
Vue.config.errorHandler = function (err, vm, info) {
  console.error('Vue error:', err, info);

  // Check if the error is from the cart component and related to cart operations
  if (vm && vm.$options.name === 'Cart') {
    // Set cart error state
    if (vm.cartError !== undefined) {
      vm.cartError = true;
      if (vm.scrollToTop) {
        vm.scrollToTop();
      }
    }
  }

  // Re-throw to allow error tracking services to catch it
  throw err;
};

var vueapp = new VueCart({
  name: 'Cart',
  el: el,
  // props: ['settingSaleAjax', 'settingFashionpromo','settingFashionpromoValue', 'flatrateVariantids', 'flatrateProdids', 'flatratePrice', 'flatrateCompprice'],
  propsData: el.dataset,
  store: vuestore,
});

function CartFreeGifts(currentShop, currentLang, hasCustomer) {
  function freeShippingFrom() {
    var countryCode = '';
    try {
      var ipShopCache = GeoRedirect.getIpShopCache();
      countryCode = ipShopCache && ipShopCache.country_code;
    } catch (err) {
      console.log('Georedirect undefined',err);
    }
    
    // app_deal_free_shipping
    /* let cart_app_free_shipping = false;
    cart_app_free_shipping = true;
   if (typeof AppUserAgentDetected !== 'undefined' && AppUserAgentDetected && hasCustomer && cart_app_free_shipping) {
      const appFreeShippingFromValue = 10;
      switch (currentShop) {
        case 'de':
          switch (countryCode) {
            case 'CH':
              break; // no free shipping
            default:
              return appFreeShippingFromValue;
          }
          break;
        case 'fr':
          switch (countryCode) {
            case 'CH':
              break; // no free shipping
            default:
              return appFreeShippingFromValue;
          }
          break;
        case 'eu':
          switch (countryCode) {
            case 'BA':
            case 'CY':
            case 'MT':
            case 'RS':
            case 'TR':
              break; // no free shipping
            default:
              return appFreeShippingFromValue;
          }
          break;
        case 'com':
          break; // no free shipping
        default:
          return appFreeShippingFromValue;
      }
    }*/

    switch(currentShop) {
      case 'de':
        switch (countryCode) {
          case 'CH':
            return 9000;
          case 'LI':
            return 9000;
        }
        return 5400;
      case 'at':
        return 5900;
      case 'fr':
        switch (countryCode) {
          case 'CH':
            return 9000;
          case 'BE':
          case 'LU':
          case 'NL':
            return 5900;
          case 'FR':
            return 5400;
        }
        return 5400;
      case 'eu':
        switch (countryCode) {
          case 'BE':
          case 'LU':
          case 'NL':
          case 'ES':
          case 'IT':
            return 5900;
        }
        return 9900;
      case 'ie':
        return 5900;
      case 'uk':
        return 5400;
      case 'au':
        return 20000;
      case 'ca':
        return 12000;
      case 'us':
        return 10000;
      case 'com':
            return 0;
      default:
        return 0;
    }
  }
function freeExpressShippingFrom() {
    var countryCode = '';
    try {
      var ipShopCache = GeoRedirect.getIpShopCache();
      countryCode = ipShopCache && ipShopCache.country_code;
    } catch (err) {
      console.log('Georedirect undefined',err);
    }
    switch(currentShop) {
      case 'de':
        switch (countryCode) {
          case 'CH':
            return 13000;
          case 'LI':
            return 0;
        }
        return 0;
      case 'at':
        return 13000;
      case 'fr':
        switch (countryCode) {
          case 'CH':
            return 13000;
          case 'BE':
          case 'LU':
          case 'NL':
            return 0;
          case 'FR':
            return 9900;
        }
        return 9900;
      case 'eu':
        switch (countryCode) {
          case 'BE':
          case 'LU':
          case 'NL':
          case 'ES':
          case 'IT':
            return 9900;
        }
        return 0;
      case 'ie':
        return 9900;
      case 'uk':
        return 9900;
      case 'au':
        return 30000;
      case 'ca':
        return 18000;
      case 'us':
        return 0;
      case 'com':
        switch (countryCode) {
          case 'CN':
          case 'DO':
            return 0;
        }
        return 20000;
      default:
        return 0;
    }
  }
  
  var gifts = [];

  var freeShippingFromValue = freeShippingFrom()
  if (freeShippingFromValue > 0) {
    gifts.push({
      title: (function () {
        switch (currentLang) {
          case 'de': return 'Standard Versand';
          case 'fr': return 'Standard Livraison';
          default: return 'standard shipping';
        }
      })(),
      value: freeShippingFromValue,
    });
  }
  var freeExpressShippingFromValue = freeExpressShippingFrom()
  if (freeExpressShippingFromValue > 0) {
    gifts.push({
      title: (function () {
        switch (currentLang) {
          case 'de': return 'Express Versand';
          case 'fr': return 'Express Livraison';
          default: return 'express shipping';
        }
      })(),
      value: freeExpressShippingFromValue,
    });
  }

 /* gifts.push({
    title: (function () {
      switch (currentLang) {
        case 'de': return '20% Extra-Rabatt';
        case 'fr': return '-20% supp.';
        default: return 'extra 20% off';
      }
    })(),
    value: (function () {
      switch (currentShop) {
        case 'de': return 9500;
        case 'at': return 9500;
        case 'fr': return 9500;
        case 'au': return 15000;
        case 'ca': return 16500;
        case 'eu': return 10000;
        case 'ie': return 9500;
        case 'uk': return 8200;
        case 'us': return 14000;
        case 'com': return 25000;
        default: return 25000;
      }
    })(),
    useOfferSubtotal: true,
  });*/

/*
 gifts.push({
    title: (function () {
      switch (currentLang) {
        case 'de': return '10% Extra-Rabatt';
        case 'fr': return '10% en plus';
        default: return 'extra 10% off';
      }
    })(),
    value: (function () {
      switch (currentShop) {
        case 'de': return 8500;
        case 'at': return 8500;
        case 'fr': return 8500;
        case 'au': return 14000;
        case 'ca': return 15000;
        case 'eu': return 9000;
        case 'ie': return 8500;
        case 'uk': return 7500;
        case 'us': return 12500;
        case 'com': return 23000;
        default: return 23000;
      }
    })(),
    useOfferSubtotal: true,
  });

  gifts.push({
    title: (function () {
      switch (currentLang) {
        case 'de': return '20% Extra-Rabatt';
        case 'fr': return '20% en plus';
        default: return 'extra 20% off';
      }
    })(),
    value: (function () {
      switch (currentShop) {
        case 'de': return 10500;
        case 'at': return 10500;
        case 'fr': return 10500;
        case 'au': return 16500;
        case 'ca': return 18000;
        case 'eu': return 11000;
        case 'ie': return 10500;
        case 'uk': return 9000;
        case 'us': return 15000;
        case 'com': return 27500;
        default: return 27500;
      }
    })(),
    useOfferSubtotal: true,
  });

  gifts.push({
    title: (function () {
      switch (currentLang) {
        case 'de': return '30% Extra-Rabatt';
        case 'fr': return '30% en plus';
        default: return 'extra 30% off';
      }
    })(),
    value: (function () {
      switch (currentShop) {
        case 'de': return 13000;
        case 'at': return 13000;
        case 'fr': return 13000;
        case 'au': return 20500;
        case 'ca': return 22500;
        case 'eu': return 14000;
        case 'ie': return 13000;
        case 'uk': return 11000;
        case 'us': return 19000;
        case 'com': return 34500;
        default: return 34500;
      }
    })(),
    useOfferSubtotal: true,
  });

*/




  

  vueapp.giftscale.settings.forEach(function(gift){
    if(vueapp.cartType == gift.category){
      gifts.push({
        title: gift.message,
        value: gift.over,
      });
    }
  });


  return {
    gifts: gifts.filter(function (item) {
      return item && item.title && item.value >= 0;
    }).sort(function (a, b) {
      return a.value > b.value ? 1 : -1;
    }),
    freeShippingFrom: freeShippingFromValue,
    freeExpressShippingFrom: freeExpressShippingFromValue,
  }
}
